import './styles.scss'
import React, { useContext, useEffect, useState, useRef, useCallback } from 'react'
import { FacebookShareButton, WhatsappShareButton, FacebookIcon, EmailShareButton, EmailIcon, LinkedinShareButton, LinkedinIcon, TwitterShareButton, TwitterIcon, TelegramShareButton, TelegramIcon } from 'react-share'
import { InputText } from 'primereact/inputtext'
import { useHistory, useLocation } from 'react-router-dom'
import { Tooltip } from 'primereact/tooltip'
import { getLocalLoggedInStatus, getLocalSingleDeviceId, getLocalTheme, getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import apiAdapterCoffeeWeb, { getURLMetadata } from 'Services/apiAdapter_CoffeeWeb'
import { useTranslation } from 'react-i18next'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { qriOS, qrPlayStore, WindowMinimizeIcon, WindowMaximizeIcon } from 'Assets/Icons'
import { Button } from 'primereact/button'
import SearchBar from 'Components/UIComponent/ExpandableSearch'
import { useResizeHandler, urlMethods } from 'Utils/commonMethods'
import { InputTextarea } from 'primereact/inputtextarea'
import { Skeleton } from 'primereact/skeleton'
import { supabase } from 'Services/supabaseClient'
import { MessageMenu } from 'Components/UIComponent/FloatingMenu'
import AttachmentMenu from 'Components/UIComponent/FloatingMenu/Attachment'
import AttachmentPreview from 'Components/UIComponent/AttachmentPreview'
import ComingSoonPopUp from 'Components/UIComponent/ComingSoonPopUp'
import URLPreview from 'Components/UIComponent/URLPreview'
import { useUrlMetadata } from 'Utils/useUrlMetadata'
import { fetchInternalCommunityMembers, fetchCommunityUnreadCount, fetchPersonalChatUnreadCount, getLastScheduledYourNews, getNewsReminderHistory, getUserNewsReminders, markNewsReminderLastRead } from 'Services/Supabase'
import REG_EX from 'Utils/Constants/RegEx'
import { subscribeToPersonalChatRealtime, subscribeToCommunityChatRealtime } from 'Services/chatRealtimeSubscriptions'
import { getPendingUrlMessages, approveMessageUrl, rejectMessageUrl, removeMessageForAdmin, blockUserFromCommunity, addUserToCommunity, createMessageWithAttachments, deleteMessageForAll, deleteMessageForMe, getCommunityMessagesWithAttachments, getGuestUserCommunities, getInternalUserCommunities, getReportReasons, getUserCommunities, removeAllMessageForUser, reportAbuse, undoReportAbuse, updateMessage, updateMessageAttachment, editMessage, fetchOlderMessages, getUserAllowPersonalChat, getMessageHasAttachmentsById, getMessageAttachmentMediaTypesByMessageId, getUserForCommunityRealtimeMessage, getMessageReplyWithUser, getCommunityMemberBlocked, getCommunityUserRole, getCanActAsBot, getCommunityMembersUnreadCounts, getKvAppSetting, subscribeToRealTimeCommunityUpdates, subscribeToRealTimeBlockCommunityMember, subscribeToRealtimeCommunity, subscribeToRealTimeCommunityMessageToTop, subscribeToRealTimeApprovalUrlLinks, fetchUserDetailsFromSupabase } from 'Services/Supabase/CoffeeCommunities'
import { YourNewsContent } from 'Screens/YourNews/Components'
import MetaTagsComponent from 'Components/MetaTagsComponent'
import { COFFEE_COMMUNITIES_CONSTANTS, COFFEE_COMMUNITIES_METHODS, COFFEE_COMMUNITIES_RENDER_HELPERS, useImageZoom, AttachmentViewerControls } from './Utils'
import ForwardMessageModal from './Components/ForwardMessageModal'
import MentionDropdown from './Components/MentionDropdown'
import PersonalChat from '../PersonalChat'

const { timeMethods, textMethods, attachmentMethods, userMethods } = COFFEE_COMMUNITIES_METHODS
const { convertMentionsToHighlighted } = textMethods
const { UploadSpinner, AttachmentIcon } = COFFEE_COMMUNITIES_RENDER_HELPERS
const { PAGE_SIZE, MAX_FILE_SIZE, MAX_FILES, RETRY_DELAY, MAX_RETRIES, BUCKET_NAME } = COFFEE_COMMUNITIES_CONSTANTS
/* eslint-disable prefer-arrow-callback */

// --- Utilities  ---

const removeMediaIndex = (id) => {
  if (!id) return id

  return id.split('-media-')[0]
}

export const ChatMessage = React.memo(
  function ChatMessage({ msg, isOutgoing, formatTime, onAttachmentClick, menuNode, onReplyClick, activeCommunity, userRoleInCommunity, onChatPersonally, internalCommunityMembers }) {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState(false)
    const [captionExpanded, setCaptionExpanded] = useState(false)

    const { isLong: isLongText, preview: previewText } = textMethods.buildPreviewText(msg?.content || '', expanded)

    const ts = msg.timestamp || msg.createdTimestamp || msg.created_at || null
    const userDetails = getLocalUserDetails()
    const contentWithLinks = textMethods.convertLinksToAnchors(previewText || '')
    // Only apply mention highlighting for internal communities, pass members for accurate name matching
    const contentWithMentions = activeCommunity?.is_internal ? convertMentionsToHighlighted(contentWithLinks, internalCommunityMembers) : contentWithLinks

    const hasTextContent = Boolean(msg?.content?.trim())
    const hasAttachments = Array.isArray(msg.attachments) && msg.attachments.length > 0
    const hasMediaAttachments = hasAttachments && msg.attachments.some((att) => attachmentMethods.isMediaAttachment(att.mime_type))
    const hasAnyCaption = hasAttachments && msg.attachments.some((att) => att.caption && att.caption.trim())
    const hasOnlyMediaAttachments = hasMediaAttachments && msg.attachments.every((att) => attachmentMethods.isMediaAttachment(att.mime_type))
    const shouldOverlayTimestamp = hasOnlyMediaAttachments && !hasTextContent && !hasAnyCaption

    const renderTimestamp = (extraClass = '') => {
      const approvalStatus = msg?.approved_status
      const hasUrl = msg?.has_url
      // Only show approval status for outgoing messages (messages sent by current user)
      const showApprovalStatus = isOutgoing && hasUrl && approvalStatus

      const getApprovalStatusLabel = () => {
        if (approvalStatus === 'PENDING') return 'Pending'
        // if (approvalStatus === 'APPROVED') return 'Approved'
        // if (approvalStatus === 'REJECTED') return 'Rejected'

        return ''
      }

      return (
        <span className={`time ${extraClass}`.trim()}>
          {showApprovalStatus && <span className="approval-status-label">&nbsp; {getApprovalStatusLabel()}</span>}
          {msg.edited_at && <span className="edited-label">Edited&nbsp;</span>}
          {ts ? formatTime(ts) : ''}
        </span>
      )
    }

    const abuseFlagCount = msg?.abuse_flag_count || 0

    return (
      <div className="bubble">
        {/* {msg?.reply_to_id && (msg?.repliedMessage || msg?.is_reply_deleted) && ( */}
        {msg?.reply_to_id && (
          <div
            className={`replied-message-preview ${isOutgoing ? 'out' : 'in'}`}
            onClick={(e) => {
              e.stopPropagation()
              if (onReplyClick && msg?.reply_to_id) {
                onReplyClick(removeMediaIndex(msg.reply_to_id))
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            <div className="user-details">
              {msg?.repliedMessage?.user?.userid === userDetails?.id ? (
                'You'
              ) : (
                <>
                  {msg?.repliedMessage?.user?.first_name?.trim() || msg?.repliedMessage?.user_info?.first_name?.trim()} {msg?.repliedMessage?.user?.last_name?.trim() || msg?.repliedMessage?.user_info?.last_name?.trim()}
                </>
              )}
            </div>
            {/*  eslint-disable-next-line */}
            <div className="replied-message-text">{msg?.is_reply_deleted ? 'Message deleted' : msg?.repliedMessage?.attachmentsType ? <AttachmentIcon type={msg?.repliedMessage?.attachmentsType} count={msg?.repliedMessage?.attachmentsCount} attachments={msg?.repliedMessage?.attachments} /> : msg?.repliedMessage?.content || ''}</div>
          </div>
        )}
        {abuseFlagCount > 0 && (
          <div className={`abuse-flag-indicator ${isOutgoing ? 'out' : 'in'}`}>
            <i className="pi pi-flag-fill" />
            <span>{abuseFlagCount}</span>
          </div>
        )}
        <div>
          {msg?.is_forwarded && (
            <div className="forwarded-label">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" className="forwarded-icon">
                <path d="m654-300-51-51 159-159-159-159 51-51 210 210-210 210Zm-510 90v-144q0-80 56-136t136-56h198L411-669l51-51 210 210-210 210-51-51 123-123H336q-50 0-85 35t-35 85v144h-72Z" />
              </svg>
              <span className="forwarded-text">{t('FORWARDED')}</span>
            </div>
          )}
          {!isOutgoing && (
            <div className="user-data">
              <img src={msg?.user_info?.users_flag_url} alt="Flag" loading="lazy" decoding="async" draggable={false} />
              <div className="user-details">
                {msg?.user_info?.first_name?.trim()} {msg?.user_info?.last_name?.trim()}
              </div>
              <div className="inline-message-options">
                {userDetails?.id && (
                  <div onClick={onChatPersonally} className="message-icon-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" height="21px" viewBox="0 -960 960 960" width="21px" className="message-icon">
                      {/* <g transform="translate(960,0) scale(-1,1)"> */}
                      <path d="M240-400h480v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM880-80 720-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v720ZM160-320h594l46 45v-525H160v480Zm0 0v-480 480Z" />
                      {/* </g> */}
                    </svg>
                  </div>
                )}
                {menuNode && userDetails?.id && !(activeCommunity?.admin_only_message && userRoleInCommunity !== 'ADMIN') && <div className="menu-node">{menuNode}</div>}
              </div>
            </div>
          )}

          {hasTextContent && (
            <div className={`text ${isOutgoing ? 'out' : 'in'} ${isLongText && !expanded ? 'clamped' : ''}`}>
              <div className={`message-content ${expanded ? 'show-less' : ''}`} dangerouslySetInnerHTML={{ __html: contentWithMentions || '' }} />
              {isLongText && (
                <div className={'read-more-btn'} onClick={() => setExpanded((prevExpanded) => !prevExpanded)}>
                  {expanded ? t('SHOW_LESS') : t('READ_MORE')}
                </div>
              )}
            </div>
          )}

          {/* URL Preview - Show only for first URL if multiple exist */}
          {msg?.url_preview && (
            <div className="message-url-preview">
              <URLPreview metadata={msg.url_preview} className="in-message" />
            </div>
          )}

          {hasAttachments &&
            (() => {
              // Separate media and documents
              const mediaAttachments = msg.attachments.filter((att) => attachmentMethods.isMediaAttachment(att.mime_type))
              const docAttachments = msg.attachments.filter((att) => !attachmentMethods.isMediaAttachment(att.mime_type))
              const mediaCount = mediaAttachments.length
              const showMediaGrid = mediaCount > 0
              // Check if multiple media with captions - if so, show stacked instead of grid
              const hasAnyMediaWithCaption = mediaAttachments.some((att) => att.caption && att.caption.trim())
              const isSplitSingleMedia = msg.splitFromMultiMedia && mediaCount === 1

              return (
                <div className={`attachment ${isOutgoing ? 'out' : 'in'}`}>
                  <div className={`attachments ${shouldOverlayTimestamp ? 'media-only' : ''}`}>
                    {/* Stacked Media Layout - When multiple media have captions */}
                    {isSplitSingleMedia && (
                      <>
                        {mediaAttachments.map((att, idx) => {
                          const originalIdx = msg.attachments.indexOf(att)
                          const isPending = att.pending || msg.pending
                          const { isLong: isLongCaption, preview: previewCaption } = textMethods.buildPreviewText(att.caption || '', captionExpanded)
                          const captionWithLinks = activeCommunity?.is_internal ? convertMentionsToHighlighted(textMethods.convertLinksToAnchors(previewCaption || ''), internalCommunityMembers) : textMethods.convertLinksToAnchors(previewCaption || '')

                          const renderAttachment = () => {
                            if (attachmentMethods.isImageAttachment(att.mime_type)) {
                              return (
                                <div className="attachment-media-container">
                                  <img src={att.media_url} alt={att.file_name} className="attachment-media" onClick={() => !isPending && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()} draggable={false} loading="eager" style={{ opacity: isPending ? 0.7 : 1, transition: 'opacity 0.2s ease-in-out' }} />
                                  {isPending && <UploadSpinner />}
                                </div>
                              )
                            }

                            if (attachmentMethods.isVideoAttachment(att.mime_type)) {
                              return (
                                <div className="video-wrapper">
                                  <video src={att.media_url} className="attachment-media" onClick={() => !isPending && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()} controlsList="nodownload" style={{ opacity: isPending ? 0.7 : 1, transition: 'opacity 0.2s ease-in-out' }} />
                                  {isPending && <UploadSpinner />}
                                  {!isPending && (
                                    <div className="play-pause-btn" onClick={() => onAttachmentClick && onAttachmentClick(msg, att, originalIdx)}>
                                      <span className="pause-icon">▶</span>
                                    </div>
                                  )}
                                </div>
                              )
                            }

                            return null
                          }

                          return (
                            <div key={originalIdx} className="attachment-item">
                              <div className="attachment-media-wrapper">
                                {renderAttachment()}
                                {!att.caption?.trim() && renderTimestamp('overlay')}
                              </div>
                              {att.caption?.trim() && (
                                <div className="attachment-caption">
                                  <span className={`message-content ${captionExpanded ? 'show-less' : ''}`} dangerouslySetInnerHTML={{ __html: captionWithLinks || '' }} />
                                  {isLongCaption && (
                                    <div className="read-more-btn" onClick={() => setCaptionExpanded((prev) => !prev)}>
                                      {captionExpanded ? t('SHOW_LESS') : t('READ_MORE')}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )
                        })}
                      </>
                    )}

                    {/* Stacked Media Layout - When any media has a caption, display each separately (for non-split messages) */}
                    {hasAnyMediaWithCaption && !isSplitSingleMedia && (
                      <>
                        {mediaAttachments.map((att, idx) => {
                          const originalIdx = msg.attachments.indexOf(att)
                          const isPending = att.pending || msg.pending
                          const { isLong: isLongCaption, preview: previewCaption } = textMethods.buildPreviewText(att.caption || '', captionExpanded)
                          const captionWithLinks = activeCommunity?.is_internal ? convertMentionsToHighlighted(textMethods.convertLinksToAnchors(previewCaption || ''), internalCommunityMembers) : textMethods.convertLinksToAnchors(previewCaption || '')

                          const renderAttachment = () => {
                            if (attachmentMethods.isImageAttachment(att.mime_type)) {
                              return (
                                <div className="attachment-media-container">
                                  <img src={att.media_url} alt={att.file_name} className="attachment-media" onClick={() => !isPending && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()} draggable={false} loading="eager" style={{ opacity: isPending ? 0.7 : 1, transition: 'opacity 0.2s ease-in-out' }} />
                                  {isPending && <UploadSpinner />}
                                </div>
                              )
                            }

                            if (attachmentMethods.isVideoAttachment(att.mime_type)) {
                              return (
                                <div className="video-wrapper">
                                  <video src={att.media_url} className="attachment-media" onClick={() => !isPending && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()} controlsList="nodownload" style={{ opacity: isPending ? 0.7 : 1, transition: 'opacity 0.2s ease-in-out' }} />
                                  {isPending && <UploadSpinner />}
                                  {!isPending && (
                                    <div className="play-pause-btn" onClick={() => onAttachmentClick && onAttachmentClick(msg, att, originalIdx)}>
                                      <span className="pause-icon">▶</span>
                                    </div>
                                  )}
                                </div>
                              )
                            }

                            return null
                          }

                          return (
                            <div key={originalIdx} className="attachment-item">
                              <div className="attachment-media-wrapper">
                                {renderAttachment()}
                                {!att.caption?.trim() && renderTimestamp('overlay')}
                              </div>
                              {att.caption?.trim() && (
                                <div className="attachment-caption">
                                  <span className={`message-content ${captionExpanded ? 'show-less' : ''}`} dangerouslySetInnerHTML={{ __html: captionWithLinks || '' }} />
                                  {isLongCaption && (
                                    <div className="read-more-btn" onClick={() => setCaptionExpanded((prev) => !prev)}>
                                      {captionExpanded ? t('SHOW_LESS') : t('READ_MORE')}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )
                        })}
                      </>
                    )}

                    {/* Media Grid Layout - WhatsApp Style (normal grid when no multiple captions) */}
                    {showMediaGrid && !hasAnyMediaWithCaption && !isSplitSingleMedia && (
                      <div className={`media-grid media-grid-${Math.min(mediaCount, 5)}`}>
                        {mediaAttachments.slice(0, 4).map((att, idx) => {
                          const originalIdx = msg.attachments.indexOf(att)
                          const isMedia = attachmentMethods.isMediaAttachment(att.mime_type)
                          const showOverlay = shouldOverlayTimestamp && isMedia && originalIdx === msg.attachments.length - 1
                          const isLastInGrid = idx === 3 && mediaCount > 4
                          const remainingCount = mediaCount - 4

                          const renderAttachment = () => {
                            const isPending = att.pending || msg.pending

                            if (attachmentMethods.isImageAttachment(att.mime_type)) {
                              return (
                                <div className="attachment-media-container">
                                  <img src={att.media_url} alt={att.file_name} className="attachment-media" onClick={() => !isPending && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()} draggable={false} loading="eager" style={{ opacity: isPending ? 0.7 : 1, transition: 'opacity 0.2s ease-in-out' }} />
                                  {isPending && <UploadSpinner />}
                                </div>
                              )
                            }

                            if (attachmentMethods.isVideoAttachment(att.mime_type)) {
                              return (
                                <div className="video-wrapper">
                                  <video src={att.media_url} className="attachment-media" onClick={() => !isPending && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()} controlsList="nodownload" style={{ opacity: isPending ? 0.7 : 1, transition: 'opacity 0.2s ease-in-out' }} />
                                  {isPending && <UploadSpinner />}
                                  {!isPending && (
                                    <div className="play-pause-btn" onClick={() => onAttachmentClick && onAttachmentClick(msg, att, originalIdx)}>
                                      <span className="pause-icon">▶</span>
                                    </div>
                                  )}
                                </div>
                              )
                            }

                            return null
                          }

                          return (
                            <div
                              key={originalIdx}
                              className={`media-grid-item ${showOverlay ? 'has-overlay' : ''} ${isLastInGrid ? 'has-remaining' : ''}`}
                              onClick={() => {
                                if (isLastInGrid && onAttachmentClick && !(att.pending || msg.pending)) {
                                  onAttachmentClick(msg, mediaAttachments[4], msg.attachments.indexOf(mediaAttachments[4]))
                                }
                              }}
                            >
                              <div className="attachment-media-wrapper">
                                {renderAttachment()}
                                {isLastInGrid && <div className="remaining-count-overlay">+{remainingCount}</div>}
                                {showOverlay && !isLastInGrid && renderTimestamp('overlay')}
                              </div>
                            </div>
                          )
                        })}
                        {/* Single media caption with Show More / Less */}
                        {mediaCount === 1 &&
                          mediaAttachments[0]?.caption &&
                          (() => {
                            const att = mediaAttachments[0]

                            const { isLong: isLongCaption, preview: previewCaption } = textMethods.buildPreviewText(att.caption || '', captionExpanded)
                            const captionWithLinks = activeCommunity?.is_internal ? convertMentionsToHighlighted(textMethods.convertLinksToAnchors(previewCaption || ''), internalCommunityMembers) : textMethods.convertLinksToAnchors(previewCaption || '')

                            return (
                              <div className="attachment-caption">
                                <span className={`message-content ${captionExpanded ? 'show-less' : ''}`} dangerouslySetInnerHTML={{ __html: captionWithLinks || '' }} />

                                {isLongCaption && (
                                  <div className="read-more-btn" onClick={() => setCaptionExpanded((prev) => !prev)}>
                                    {captionExpanded ? t('SHOW_LESS') : t('READ_MORE')}
                                  </div>
                                )}
                              </div>
                            )
                          })()}
                      </div>
                    )}

                    {/* Document attachments (non-media) */}
                    {docAttachments.map((att, idx) => {
                      const originalIdx = msg.attachments.indexOf(att)
                      const { isLong: isLongCaption, preview: previewCaption } = textMethods.buildPreviewText(att.caption || '', captionExpanded)

                      return (
                        <div key={`doc-${originalIdx}`} className="attachment-item">
                          <div className="attachment-doc" onClick={() => !(att.pending || msg.pending) && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()}>
                            <i className="pi pi-file" />
                            <span className="file-name">{att.file_name}</span>
                            {(att.pending || msg.pending) && <UploadSpinner />}
                          </div>
                          {att.caption && (
                            <div className="attachment-caption">
                              <span className={`message-content ${captionExpanded ? 'show-less' : ''}`} dangerouslySetInnerHTML={{ __html: activeCommunity?.is_internal ? convertMentionsToHighlighted(textMethods.convertLinksToAnchors(previewCaption || ''), internalCommunityMembers) : textMethods.convertLinksToAnchors(previewCaption || '') || '' }} />
                              {isLongCaption && (
                                <div className="read-more-btn" onClick={() => setCaptionExpanded((prev) => !prev)}>
                                  {captionExpanded ? t('SHOW_LESS') : t('READ_MORE')}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })()}

          {/* Timestamp placement */}
          {hasAttachments && !shouldOverlayTimestamp && renderTimestamp(hasTextContent ? 'caption' : '')}
          {!hasAttachments && hasTextContent && renderTimestamp()}
        </div>
      </div>
    )
  },
  (prev, next) => prev.isOutgoing === next.isOutgoing && prev.msg.id === next.msg.id && prev.msg.content === next.msg.content && prev.msg.timestamp === next.msg.timestamp && prev.msg?.user?.users_flag_url === next.msg?.user?.users_flag_url && prev.msg?.user?.first_name === next.msg?.user?.first_name && prev.msg?.user?.last_name === next.msg?.user?.last_name && prev.msg?.edited_at === next.msg?.edited_at && prev.msg?.reply_to_id === next.msg?.reply_to_id && prev.msg?.repliedMessage === next.msg?.repliedMessage && prev.msg?.abuse_flag_count === next.msg?.abuse_flag_count && prev.onAttachmentClick === next.onAttachmentClick && prev.onReplyClick === next.onReplyClick && prev.activeCommunity?.id === next.activeCommunity?.id && prev.activeCommunity?.admin_only_message === next.activeCommunity?.admin_only_message && prev.userRoleInCommunity === next.userRoleInCommunity
)

const handleReply = (msg, setRepliedMessage, repliedMsgRef, inputRef, attachmentIndex = null) => {
  // Create a shallow copy so we don't mutate the original message object
  const replied = { ...msg }

  // If a specific attachment index was provided, store it so UI knows which attachment
  // the user is replying to. Keep it null/undefined when replying to the message text.
  if (attachmentIndex !== null && attachmentIndex !== undefined) {
    replied.replyAttachmentIndex = attachmentIndex
  }

  setRepliedMessage(replied)

  if (inputRef && inputRef.current) {
    inputRef.current.focus()
  }

  if (repliedMsgRef) {
    // eslint-disable-next-line no-param-reassign
    repliedMsgRef.current = replied
  }
}

// --- CommunityRow (TOP-LEVEL) ---
export const CommunityRow = React.memo(
  function CommunityRow({ groupData, index, activeId, onClick, isCoffeePost }) {
    const isCreateOwn = groupData?.isCreateOwn
    const isYourNews = groupData?.isYourNews
    const yourNewsTimeLabel = React.useMemo(() => {
      if (!isYourNews || !groupData?.yourNewsReminderTime) return ''

      const date = new Date(groupData.yourNewsReminderTime)

      if (Number.isNaN(date.getTime())) return ''

      const now = new Date()
      const isToday = date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate()

      const timePart = date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })

      return isToday ? `Today, ${timePart}` : timePart
    }, [isYourNews, groupData?.yourNewsReminderTime])

    const renderCommunityAvatar = () => {
      if (isCreateOwn) {
        return <i className="pi pi-plus-circle create-own-icon" aria-hidden="true" />
      }

      if (groupData?.isUrlApproval) {
        return <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png" alt="active-community-logo" />
      }

      if (groupData?.community_url) {
        return <img alt="community-logo" src={groupData.community_url} loading="lazy" decoding="async" draggable={false} />
      }

      return <div className="avatar-text">{groupData?.name?.[0]}</div>
    }

    const renderRightContent = () => {
      const uc = groupData?.unread_count ?? 0
      const isHidden = groupData.id === activeId || !(uc > 0 && uc <= 99)

      let unreadText = ''

      if (uc > 0 && uc <= 99) {
        unreadText = uc
      } else if (uc > 99) {
        unreadText = '99+'
      }

      return <div className={`unread-count-div ${isHidden ? 'active' : ''}`}>{unreadText}</div>
    }

    return (
      <div className={`community-item ${groupData.id === activeId ? 'active' : ''} ${isCoffeePost ? 'coffee-post-item' : ''}`} onClick={() => onClick(groupData)}>
        <div className={`community-name ${groupData.id === activeId ? 'active' : ''}`}>
          {renderCommunityAvatar()}
          {/* <img alt="community-logo" src={groupData.community_url || 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png'} loading="lazy" decoding="async" draggable={false} /> */}
          <div className="community-title-wrap">
            <span>{groupData.name}</span>
            {isYourNews && !!yourNewsTimeLabel && <div className="your-news-reminder-time">{yourNewsTimeLabel}</div>}
          </div>
        </div>
        <div className="unread-subscription-info-container">{renderRightContent()}</div>
      </div>
    )
  },
  (prev, next) =>
    // Ignore handler identity; compare only meaningful data
    prev.activeId === next.activeId && prev.index === next.index && prev.groupData.id === next.groupData.id && prev.groupData.name === next.groupData.name && prev.groupData.community_url === next.groupData.community_url && prev.groupData.unread_count === next.groupData.unread_count && prev.groupData.isUrlApproval === next.groupData.isUrlApproval && prev.groupData.isYourNews === next.groupData.isYourNews && prev.groupData.yourNewsReminderTime === next.groupData.yourNewsReminderTime
)

const CoffeeCommunities = ({ componentLabel, isCoffeePost, selectedCommunityId, onCommunitySelect, onBackToCommunities, hasHeader, onUnreadCountRefresh, onSwitchToPersonalChat }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const { setLoading } = useContext(CoffeeWebContext)
  const repliedMsgRef = useRef(null)
  const uploaderRef = useRef()
  const userDetails = getLocalUserDetails()
  const isPersonalChatAvailable = userDetails?.isUserpersionalchat
  const [theme, setTheme] = useState(getLocalTheme() || 'light')

  const { isWebView } = useResizeHandler()
  const userLoginStatus = getLocalLoggedInStatus()

  const inputRef = useRef(null)
  const containerRef = useRef(null)
  const earliestTimestampRef = useRef(null) // min timestamp we currently have
  const existingIdsRef = useRef(new Set()) // set of ids we already added
  const isInitialLoadRef = useRef(true)
  const isFetchingRef = useRef(false)
  const hasMoreRef = useRef(true)
  const nextCursorRef = useRef(null)
  const editInputRef = useRef(null)
  const previewRef = useRef(null)
  // Ref that always holds current active community ID - avoids stale closure in async fetchOlderChats
  const activeCommunityIdRef = useRef(null)
  // Ref for groupList so message-INSERT handler can use current list without stale closure
  const groupListRef = useRef([])
  const prevActiveTabRef = useRef('communities')

  const params = new URLSearchParams(location.search)
  const view = params.get('view')

  useEffect(() => {
    const updateTheme = () => {
      const theme = getLocalTheme()

      setTheme(theme)
    }

    window.addEventListener('themeChanged', updateTheme)

    return () => {
      window.removeEventListener('themeChanged', updateTheme)
    }
  }, [])
  const updateCommunitySearchParam = React.useCallback(
    (communityId) => {
      const params = new URLSearchParams(location.search)
      const currentView = params.get('view') // Read view from current location.search

      // Don't modify params if we're on coffee-post view
      if (currentView === ROUTE_STRINGS.coffeePost) {
        return
      }

      if (communityId && currentView !== ROUTE_STRINGS.coffeePost) {
        params.set('communityId', String(communityId))
      } else {
        params.delete('communityId')
      }

      const searchString = params.toString()

      history.replace({
        pathname: location.pathname,
        search: searchString ? `?${searchString}` : ''
      })
    },
    [history, location.pathname, location.search]
  )

  // Sync URL params (chatTab, userId) with state when view=coffee-community (same pattern as CoffeePost)
  const coffeeCommunityView = 'coffee-community'

  useEffect(() => {
    if (view !== coffeeCommunityView) return

    const params = new URLSearchParams(location.search)
    const chatTab = params.get('chatTab')
    const userId = params.get('userId')

    if (chatTab === 'personalChat') {
      if (userDetails?.id) {
        setActiveTab('personalChats')
        setPersonalChatSelectedUserId(userId || null)
      } else {
        setActiveTab('communities')
        setPersonalChatSelectedUserId(null)
        params.set('chatTab', 'communities')
        params.delete('userId')
        history.replace({ pathname: location.pathname, search: params.toString() })
      }
    } else if (chatTab === 'communities') {
      setActiveTab('communities')
      setPersonalChatSelectedUserId(null)
    } else {
      setActiveTab('communities')
      setPersonalChatSelectedUserId(null)
      params.set('chatTab', 'communities')
      params.delete('userId')
      history.replace({ pathname: location.pathname, search: params.toString() })
    }
  }, [view, location.search, history, location.pathname, userDetails?.id])

  useEffect(() => {
    if (view !== coffeeCommunityView || isCoffeePost) return

    const paramsFromUrl = new URLSearchParams(location.search)
    const communityIdFromUrl = paramsFromUrl.get('communityId')

    if (!communityIdFromUrl) return

    const targetCommunity = filteredGroupList.find((c) => String(c.id) === String(communityIdFromUrl))

    if (!targetCommunity) return

    if (String(activeId) === String(targetCommunity.id)) return

    activeCommunityIdRef.current = targetCommunity.id
    setActiveCommunity(targetCommunity)
    setActiveId(targetCommunity.id)
    setValue('')
    setRepliedMessage(null)
    setAttachments([])
    setUserRoleInCommunity(null)
    setPendingUrlMessages([])
    setPendingUrlsError(null)
  }, [view, location.search, isCoffeePost])

  const fetchUnreadCounts = useCallback(async () => {
    if (!userDetails?.id) {
      setPersonalUnreadCount(0)
      setCommunityUnreadCount(0)

      return
    }

    try {
      const [personalChatCount, communityCount] = await Promise.all([fetchPersonalChatUnreadCount(userDetails), fetchCommunityUnreadCount(userDetails)])

      setPersonalUnreadCount(personalChatCount)
      setCommunityUnreadCount(communityCount)
    } catch {
      setPersonalUnreadCount(0)
      setCommunityUnreadCount(0)
    }
  }, [userDetails?.id])

  useEffect(() => {
    if (!userDetails?.id) {
      setPersonalUnreadCount(0)
      setCommunityUnreadCount(0)

      return
    }

    fetchUnreadCounts()

    const personalCleanup = subscribeToPersonalChatRealtime({
      channelName: 'personal-chat-realtime',
      userId: userDetails?.id,
      onMessage: () => {
        fetchUnreadCounts()
      }
    })

    const communityCleanup = subscribeToCommunityChatRealtime({
      channelName: 'community-chat-realtime',
      userId: userDetails?.id,
      onMessage: () => {
        fetchUnreadCounts()
      }
    })

    return () => {
      personalCleanup()
      communityCleanup()
    }
  }, [userDetails?.id, fetchUnreadCounts])

  // const [showReadMore, setShowReadMore] = useState(false) /  Commented for Read More and Show Less Functionality
  const [expanded, setExpanded] = useState(false)
  const [activeId, setActiveId] = useState('')
  const [chats, setChats] = useState([])
  const [value, setValue] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [activeSocialMediaLists, setActiveSocialMediaLists] = useState('')
  const [shortenUrl, setShortenUrl] = useState('')
  const [isCopied, setIsCopied] = useState(false)
  const [searchCommunityTerm, setSearchCommunityTerm] = useState('')
  const [groupList, setGroupList] = useState([])
  const [activeCommunity, setActiveCommunity] = useState('')
  const [selectedHistoryEntries, setSelectedHistoryEntries] = useState([])
  const [reminders, setReminders] = useState([])
  const [dataLoading, setDataLoading] = useState(false)

  const [isCommunitiesLoading, setIsCommunitiesLoading] = useState(true)
  const [createCommunityInstructions, setCreateCommunityInstructions] = useState([])
  // const [nextCursor, setNextCursor] = useState(null) // Commented if chat scroll through cursor
  const [isFetchingOlder, setIsFetchingOlder] = useState(false)
  const [filteredGroupList, setFilteredGroupList] = useState(groupList)
  const [repliedMessage, setRepliedMessage] = useState(null)
  const [isChatScrollable, setIsChatScrollable] = useState(false)
  const [showRedirectText, setShowRedirectText] = useState(false)
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [modalAction, setModalAction] = useState(null) // 'deleteForMe' | 'deleteForEveryone' | 'edit'
  const [modalMessage, setModalMessage] = useState(null)
  const [indexState, setIndexState] = useState(null)
  const [editValue, setEditValue] = useState('')
  const [isAdminUser, setIsAdminUser] = useState(false)
  const [isBlocked, setIsBlocked] = useState(false)
  const [showBlockedModal, setShowBlockedModal] = useState(false)
  const [userRoleInCommunity, setUserRoleInCommunity] = useState(null)
  const [reportReasons, setReportReasons] = useState([])
  const [selectedReportReason, setSelectedReportReason] = useState(null)
  const [isReporting, setIsReporting] = useState(false)
  const [unreadCount, setUnreadCount] = useState(0)
  const [attachments, setAttachments] = useState([]) // array of { file, previewUrl, type: 'media'|'doc', name, size }
  const [isUploadingImage, setIsUploadingImage] = useState(false)
  // URL approval state
  const [pendingUrlMessages, setPendingUrlMessages] = useState([])
  const [pendingUrlsError, setPendingUrlsError] = useState(null)
  const [isUrlActionLoading, setIsUrlActionLoading] = useState(false)
  const [copiedUrlId, setCopiedUrlId] = useState(null)

  // Forward message state
  const [forwardModalVisible, setForwardModalVisible] = useState(false)
  const [messageToForward, setMessageToForward] = useState(null)
  const [isForwarding, setIsForwarding] = useState(false)
  const [forwardSearchTerm, setForwardSearchTerm] = useState('')
  const [selectedCommunitiesForForward, setSelectedCommunitiesForForward] = useState([])

  // URL preview state
  const [inputPreviewUrl, setInputPreviewUrl] = useState(null)
  const [inputPreviewMetadata, setInputPreviewMetadata] = useState(null)

  // Personal Chat state
  const [activeTab, setActiveTab] = useState('communities')
  const [personalChatSidebarData, setPersonalChatSidebarData] = useState(null)
  const [personalChatSelectedUserId, setPersonalChatSelectedUserId] = useState(null)
  const [personalUnreadCount, setPersonalUnreadCount] = useState(0)
  const [communityUnreadCount, setCommunityUnreadCount] = useState(0)

  // Mention/User autocomplete state
  const [internalCommunityMembers, setInternalCommunityMembers] = useState([])
  const [showMentionDropdown, setShowMentionDropdown] = useState(false)
  const [mentionSearchTerm, setMentionSearchTerm] = useState('')
  const [selectedMentionIndex, setSelectedMentionIndex] = useState(0)
  const [mentionStartPosition, setMentionStartPosition] = useState(null)

  // Edit modal mention autocomplete state (for internal communities)
  const [showEditMentionDropdown, setShowEditMentionDropdown] = useState(false)
  const [editMentionSearchTerm, setEditMentionSearchTerm] = useState('')
  const [selectedEditMentionIndex, setSelectedEditMentionIndex] = useState(0)
  const [editMentionStartPosition, setEditMentionStartPosition] = useState(null)

  // URL detection function

  // Extract all URLs from text

  //   return false
  // }

  // Use URL metadata hook for input preview
  const firstUrlInInput = urlMethods.getFirstUrl(value)
  // Always enable the hook - it will handle preventing duplicate fetches internally
  const { metadata: inputMetadata, isLoading: isInputMetadataLoading } = useUrlMetadata(
    firstUrlInInput,
    Boolean(firstUrlInInput) // Only enable if there's a URL
  )

  // Update input preview when metadata is fetched
  useEffect(() => {
    if (firstUrlInInput) {
      setInputPreviewUrl(firstUrlInInput)
      // Update metadata when it's available
      // Check if metadata URL matches (with or without protocol normalization)
      if (inputMetadata) {
        const metadataUrl = inputMetadata.url || ''
        const normalizedMetadataUrl = textMethods.normalizeUrl(metadataUrl)
        const normalizedInputUrl = textMethods.normalizeUrl(firstUrlInInput)

        if (normalizedMetadataUrl === normalizedInputUrl || metadataUrl === firstUrlInInput || inputMetadata.url === firstUrlInInput) {
          setInputPreviewMetadata(inputMetadata)
        }
      } else if (!isInputMetadataLoading) {
        // Clear metadata if loading is done but no metadata (error or invalid response)
        setInputPreviewMetadata(null)
      }
    } else {
      setInputPreviewUrl(null)
      setInputPreviewMetadata(null)
    }
  }, [firstUrlInInput, inputMetadata, isInputMetadataLoading])

  // Global paste listener - works even when AttachmentPreview is showing
  useEffect(() => {
    const handleWindowPaste = (e) => {
      // Only handle if user is in the chat area (not typing elsewhere)
      // Check if active element is not a text input outside our component
      const isInOurComponent = e.target.closest('.chat-input') || e.target.closest('.input-area') || e.target.closest('.input-area-container')

      // Call our paste handler if we're in the right area or if it's a global paste
      if (!e.target.matches('input[type="text"], textarea, [contenteditable="true"]') || isInOurComponent) {
        handlePaste(e)
      }
    }

    // Listen for paste events on window
    document.addEventListener('paste', handleWindowPaste, true)

    return () => {
      document.removeEventListener('paste', handleWindowPaste, true)
    }
  }, [attachments]) // Re-attach when attachments change

  // Close mention dropdown when clicking outside
  useEffect(() => {
    function handleDocMouseDown(e) {
      if (!inputRef.current) return
      const inputContainer = inputRef.current.closest('.input-area-container')
      const mentionDropdown = document.querySelector('.mention-dropdown')

      if (showMentionDropdown && inputContainer && mentionDropdown) {
        if (!inputContainer.contains(e.target) && !mentionDropdown.contains(e.target)) {
          setShowMentionDropdown(false)
          setMentionSearchTerm('')
          setMentionStartPosition(null)
          setSelectedMentionIndex(0)
        }
      }
    }

    if (showMentionDropdown) {
      document.addEventListener('mousedown', handleDocMouseDown)
    }

    return () => {
      document.removeEventListener('mousedown', handleDocMouseDown)
    }
  }, [showMentionDropdown])

  // Clear mention state and fetch members when community changes
  useEffect(() => {
    setShowMentionDropdown(false)
    setMentionSearchTerm('')
    setMentionStartPosition(null)
    setSelectedMentionIndex(0)

    if (activeCommunity?.is_internal && activeCommunity?.id) {
      handleFetchInternalCommunityMembers(activeCommunity)
    } else {
      setInternalCommunityMembers([])
    }
  }, [activeCommunity?.id]) // eslint-disable-line react-hooks/exhaustive-deps

  // Reset selected mention index when search term changes
  useEffect(() => {
    if (showMentionDropdown) {
      setSelectedMentionIndex(0)
    }
  }, [mentionSearchTerm, showMentionDropdown])

  // Reset edit mention index when search term changes
  useEffect(() => {
    if (showEditMentionDropdown) {
      setSelectedEditMentionIndex(0)
    }
  }, [editMentionSearchTerm, showEditMentionDropdown])

  const addFiles = (fileList, kind) => {
    if (!fileList || !fileList.length) return

    const incoming = fileList.map((f, i) => {
      // Only assign the input value as caption to the very first file if it's the first batch
      // Subsequent files should have empty captions (user can edit them individually)
      const isFirstFileInFirstBatch = i === 0 && attachments.length === 0

      return {
        file: f,
        name: f.name,
        size: f.size,
        mime: f.type,
        kind, // 'media' or 'doc'
        previewUrl: kind === 'media' ? URL.createObjectURL(f) : null,
        id: `att-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        caption: isFirstFileInFirstBatch ? value?.trim() || '' : '',
        sourceMessage: isFirstFileInFirstBatch ? Boolean(value?.trim()) : false
      }
    })

    const errors = []
    const allowedNow = MAX_FILES - attachments.length

    if (incoming.length > allowedNow) {
      errors.push(`You can attach up to ${MAX_FILES} files. You can add ${allowedNow} more.`)
    }

    const validated = []

    for (let i = 0; i < Math.min(incoming.length, allowedNow); i++) {
      const it = incoming[i]

      let valid = true

      if (it.size > MAX_FILE_SIZE) {
        errors.push(`${it.name} exceeds maximum size of ${MAX_FILE_SIZE / (1024 * 1024)}MB`)
        valid = false
      }

      if (valid && kind === 'media') {
        const ok = /^(image|video)\//.test(it.mime)

        if (!ok) {
          errors.push(`${it.name} is not a supported media file`)
          valid = false
        }
      } else if (valid) {
        const ok = /\.(pdf|docx|doc|xls|xlsx|csv|txt)$/i.test(it.name)

        if (!ok) {
          errors.push(`${it.name} is not a supported document type`)
          valid = false
        }
      }

      if (valid) validated.push(it)
    }

    if (errors.length) {
      // you can surface these through UI; for now use console and a user-facing alert
      // minimal UI feedback
      alert(errors.join('\n'))
    }

    // if (validated.length) {
    //   setAttachments((prev) => [...prev, ...validated])
    // }

    return validated // Return the validated attachments instead of setting state
  }

  const [viewer, setViewer] = useState({
    open: false,
    type: null,
    url: '',
    name: '',
    attachments: [], // All attachments in the message
    currentIndex: 0 // Current attachment being viewed
  })

  const [isFullscreen, setIsFullscreen] = useState(false)

  // Reusable zoom hook (same as PersonalChat)
  const { zoomContainerRef, imgRef, handleWheelZoom, handlePointerDown, handlePointerMove, handlePointerUp, handleZoomIn, handleZoomOut, getTransformStyle, zoomLevel } = useImageZoom(viewer.url)

  const openViewer = (msg, att, index) => {
    const attachmentUrl = att.attachment_url || att.media_url || ''

    const attachmentType = att.mime_type || att.mime || ''

    const isDoc = attachmentType === 'application/msword' || attachmentType === 'application/vnd.ms-excel' || attachmentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || attachmentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

    if (isDoc) {
      const link = document.createElement('a')

      link.href = attachmentUrl
      link.download = att.file_name
      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)

      return
    }

    setViewer({
      open: true,
      type: att.mime_type,
      url: att.media_url,
      name: `${userDetails?.id === msg?.user_info?.userid ? 'You' : `${msg?.user_info?.first_name} ${msg?.user_info?.last_name}`} `,
      attachments: msg.attachments || [],
      currentIndex: index
    })
  }

  const closeViewer = () => {
    setViewer({
      open: false,
      type: null,
      url: '',
      name: '',
      attachments: [],
      currentIndex: 0
    })
    setIsFullscreen(false) // Reset fullscreen when closing
  }

  // Add navigation functions
  const navigateAttachment = (direction) => {
    const { attachments, currentIndex } = viewer

    if (!attachments || attachments.length === 0) return

    let newIndex

    if (direction === 'prev') {
      newIndex = currentIndex > 0 ? currentIndex - 1 : attachments.length - 1
    } else {
      newIndex = currentIndex < attachments.length - 1 ? currentIndex + 1 : 0
    }

    const newAtt = attachments[newIndex]

    setViewer({
      ...viewer,
      url: newAtt.media_url,
      type: newAtt.mime_type,
      currentIndex: newIndex
    })
  }

  // Add keyboard navigation
  useEffect(() => {
    if (!viewer.open) return

    const handleKeyPress = (e) => {
      if (e.key === 'ArrowLeft') {
        navigateAttachment('prev')
      } else if (e.key === 'ArrowRight') {
        navigateAttachment('next')
      } else if (e.key === 'Escape') {
        closeViewer()
      }
    }

    window.addEventListener('keydown', handleKeyPress)

    return () => window.removeEventListener('keydown', handleKeyPress)
  }, [viewer.open, viewer.currentIndex])

  const viewerModalContent = () => {
    if (!viewer.url) return null
    const isImage = attachmentMethods.isImageAttachment(viewer.type)
    const isVideo = attachmentMethods.isVideoAttachment(viewer.type)
    const isPdf = viewer.type === 'application/pdf' || viewer.name?.toLowerCase().endsWith('.pdf')
    const hasMultipleImages = viewer.attachments && viewer.attachments.length > 1

    // Only show navigation for images
    const showNavigation = hasMultipleImages

    return (
      <div className={`attachment-viewer-content ${isFullscreen ? 'fullscreen' : ''}`}>
        <div className="attachment-viewer-wrapper">
          {isImage && (
            <div ref={zoomContainerRef} className="attachment-zoom-container" onWheel={handleWheelZoom} onPointerDown={handlePointerDown} onPointerMove={handlePointerMove} onPointerUp={handlePointerUp} onPointerCancel={handlePointerUp} style={{ position: 'relative', overflow: 'hidden', touchAction: 'none', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img
                src={viewer.url}
                alt={viewer.name}
                ref={imgRef}
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: getTransformStyle(),
                  transformOrigin: 'center center',
                  maxWidth: '100%',
                  maxHeight: '100%',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  cursor: zoomLevel > 1 ? 'move' : 'default'
                }}
                onContextMenu={(e) => e.preventDefault()}
                draggable={false}
              />
            </div>
          )}
          {isVideo && <video src={viewer.url} controls autoPlay={true} style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain' }} controlsList="nodownload noplaybackrate" disablePictureInPicture onContextMenu={(e) => e.preventDefault()} />}
          {isPdf && (
            <iframe
              src={viewer.url}
              title={viewer.name}
              onContextMenu={(e) => e.preventDefault()}
              style={{
                width: 'auto',
                minWidth: '90%',
                height: '100%',
                border: 'none',
                display: 'block',
                margin: '0 auto'
              }}
            />
          )}
        </div>
        {/* Kept for future reference */}
        {/* {viewer.attachments.length > 0 && <div className="attachment-viewer-caption">{viewer.attachments[viewer.currentIndex]?.caption}</div>} */}
        {/* Navigation Arrows */}
        {showNavigation && (
          <>
            <button className="nav-arrow nav-arrow-left" onClick={() => navigateAttachment('prev')} aria-label="Previous image">
              <i className="pi pi-chevron-left" />
            </button>
            <button className="nav-arrow nav-arrow-right" onClick={() => navigateAttachment('next')} aria-label="Next image">
              <i className="pi pi-chevron-right" />
            </button>
            <div className="image-counter">
              {viewer.currentIndex + 1} / {viewer.attachments.length}
            </div>
          </>
        )}
      </div>
    )
  }

  const handleMediaSelected = (files) => {
    const newAttachments = addFiles(files, 'media')

    if (newAttachments?.length) {
      setAttachments((prev) => [...prev, ...newAttachments])
      setValue('')
    }
  }

  const handleDocumentSelected = (files) => {
    const newAttachments = addFiles(files, 'doc')

    if (newAttachments?.length) {
      setAttachments((prev) => [...prev, ...newAttachments])
      setValue('')
    }
  }

  const handlePaste = (e) => {
    const clipboard = e.clipboardData

    if (!clipboard) return

    const imageFiles = Array.from(clipboard.files).filter((file) => file.type.startsWith('image/'))

    if (imageFiles.length === 0) return

    e.preventDefault()

    // Important: clone file into new File object with unique naming
    const timestamp = Date.now()
    const randomId = Math.random().toString(36).slice(2, 8)

    const clonedFiles = imageFiles.map(
      (file, index) =>
        new File([file], `${timestamp}-${index}-${randomId}-${file.name}`, {
          type: file.type
        })
    )

    const newAttachments = addFiles(clonedFiles, 'media')

    if (newAttachments?.length) {
      setAttachments((prev) => [...prev, ...newAttachments])
    }

    // Force focus back immediately after paste - multiple times to ensure it sticks
    if (inputRef.current) {
      inputRef.current.focus()
    }

    // Double-check focus after state updates complete
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus()
      }
    }, 0)
  }

  const removeAttachment = (attId) => {
    setAttachments((prev) => {
      const found = prev.find((p) => p.id === attId)

      if (found && found.previewUrl) URL.revokeObjectURL(found.previewUrl)

      return prev.filter((p) => p.id !== attId)
    })
  }

  const openConfirmationModal = (action, msg, index) => {
    if (!userDetails?.id) {
      setShowRedirectText(true)

      return
    }

    setModalAction(action)
    setIndexState(index)
    setModalMessage(msg)
    setConfirmationModal(true)
    if (action === 'edit') {
      const contentText = (msg.content || '').trim()
      const attachmentCaption = msg.attachments && typeof index === 'number' && msg.attachments[index] && msg.attachments[index].caption ? String(msg.attachments[index].caption).trim() : ''

      setEditValue((contentText || attachmentCaption).trim())
    }
  }

  const handleModalConfirm = async () => {
    if (modalAction === 'deleteForMe') {
      await handleDeleteForMe(modalMessage, indexState)
    } else if (modalAction === 'deleteForEveryone') {
      await handleDeleteForEveryone(modalMessage, indexState)
    } else if (modalAction === 'edit' && editValue) {
      // Check if edited message contains URLs (in content or attachment captions)
      const messageAttachments = modalMessage.attachments || []
      const messageHasUrl = urlMethods.hasUrlInMessage(editValue, messageAttachments)
      // Prepare update payload
      const updatePayload = {
        content: editValue.trim(),
        edited_at: new Date().toISOString()
      }
      const captionUpdatePayload = {
        caption: editValue.trim(),
        updated_at: new Date().toISOString()
      }

      // Update has_url and approved_status based on URL detection
      if (messageHasUrl) {
        updatePayload.has_url = true
        updatePayload.approved_status = 'PENDING'
      } else if (modalMessage.has_url) {
        // If message previously had URL but now doesn't, clear the URL flags
        updatePayload.has_url = false
        updatePayload.approved_status = null
      }

      if (modalMessage.attachments.length > 0) {
        await Promise.all([updateMessageAttachment(captionUpdatePayload, modalMessage.attachments[indexState].id), updateMessage(updatePayload.edited_at, modalMessage.id)])
        // Update local state with all changes
        setChats((prev) =>
          prev.map((msg) => {
            if (msg.id !== modalMessage.id) return msg

            return {
              ...msg,
              edited_at: updatePayload.edited_at,
              attachments: (msg.attachments || []).map((att) => {
                if (att.id === modalMessage.attachments[indexState].id) {
                  return {
                    ...att,
                    caption: editValue,
                    updated_at: captionUpdatePayload.updated_at
                  }
                }

                return att
              })
            }
          })
        )
      } else {
        await editMessage(modalMessage.id, updatePayload)
        // Update local state with all changes
        setChats((prev) => prev.map((msg) => (msg.id === modalMessage.id ? { ...msg, ...updatePayload } : msg)))
      }
    } else if (modalAction === 'deleteMessageByAdmin') {
      await handleDeleteMessageByAdmin(modalMessage)
    } else if (modalAction === 'deleteAllMessageByAdmin') {
      await handleDeleteAllMessageByAdmin(modalMessage)
    } else if (modalAction === 'blockUserByAdmin') {
      await handleBlockUserByAdmin(modalMessage)
    } else if (modalAction === 'reportAbuse') {
      await handleReportAbuse(modalMessage)
    }
    setConfirmationModal(false)
    setModalAction(null)
    setModalMessage(null)
    setEditValue('')
  }

  const renderAttachments = (attachment, index) => {
    if (attachment?.attachments[index]?.attachment_type === 'image' || attachment?.attachments[index]?.media_type === 'image') {
      return <img src={attachment.attachments[index].media_url} alt="img" className="edit-image" />
    }

    if (attachment?.attachments[index]?.attachment_type === 'video' || attachment?.attachments[index]?.media_type === 'video') {
      return (
        <div className="edit-video-wrapper">
          <video className="edit-video" src={attachment.attachments[index].media_url} />
          <div className="play-pause-btn">
            <span className="pause-icon">▶</span>
          </div>
        </div>
      )
    }

    if (attachment?.attachments[index]?.attachment_type === 'document' || attachment?.attachments[index]?.media_type === 'document') {
      return (
        <div className="document-file">
          <i className="pi pi-file" />
          {attachment.attachments[index].file_name}
        </div>
      )
    }
  }

  const confirmationModalContent = () => {
    if (!modalMessage) return null

    if (modalAction === 'edit') {
      return (
        <div className="edit-modal-content">
          {modalMessage.attachments?.length > 0 && <div className="modalmessage-image">{renderAttachments(modalMessage, indexState)}</div>}
          <div className={`message-preview${expanded ? ' expanded' : ''}`} ref={previewRef}>
            <div>{modalMessage.content || modalMessage?.attachments[indexState]?.caption}</div>
            <div className="time">{formatTime(modalMessage.timestamp)}</div>
          </div>
        </div>
      )
    }
    if (modalAction === 'reportAbuse') {
      return (
        <div className="edit-modal-content">
          <div className="reported-message-box">
            <h5>Reported message:</h5>
            <span className="reported-content">{modalMessage.content}</span>
          </div>{' '}
          <br />
          <div style={{ marginBottom: 16, fontSize: 15 }}>Please select a reason for reporting this message:</div>
          <form>
            {reportReasons.length === 0 ? (
              <div>Loading reasons...</div>
            ) : (
              reportReasons.map((reason) => (
                <label key={reason.id} style={{ display: 'block', margin: '8px 0', cursor: 'pointer' }}>
                  <input type="radio" name="reportReason" value={reason.id} checked={selectedReportReason === reason.id} onChange={() => setSelectedReportReason(reason.id)} style={{ marginRight: 8 }} />
                  {reason?.display_name}
                </label>
              ))
            )}
          </form>
        </div>
      )
    }

    let confirmationHeading = 'Do you wish to proceed with this action?'
    let confirmationText = ''

    if (modalAction === 'deleteForMe') {
      confirmationHeading = 'Delete message for me'
      confirmationText = 'Do you wish to delete this message for yourself? This action cannot be undone.'
    } else if (modalAction === 'deleteForEveryone') {
      confirmationHeading = 'Delete message for everyone?'
      confirmationText = 'Do you wish to delete this message for everyone in this community? This action cannot be undone.'
    } else if (modalAction === 'deleteMessageByAdmin') {
      confirmationHeading = "Delete User's Message" // eslint-disable-line quotes
      confirmationText = 'Do you wish to delete the message of this User in this community? This action cannot be undone.'
    } else if (modalAction === 'deleteAllMessageByAdmin') {
      confirmationHeading = "Delete User's Message" // eslint-disable-line quotes
      confirmationText = 'Do you wish to delete all the message of this User in this community? This action cannot be undone.'
    } else if (modalAction === 'blockUserByAdmin') {
      confirmationHeading = 'Block User' // eslint-disable-line quotes
      confirmationText = 'Do you wish to Block this User in this community? This action cannot be undone.'
    }

    return (
      <div>
        {/* <div className="confirmation-modal-content">{confirmationHeading}</div> */}
        <div className="message-preview">{confirmationText}</div>
        {/* commented for message preview */}
        {/* <div className="message-preview">{modalMessage.content}</div> */}
      </div>
    )
  }

  const handleEditChange = (newValue) => {
    setEditValue(newValue)

    if (editInputRef.current) {
      textMethods.autoResizeTextarea(editInputRef.current)
    }

    // Handle @ mention detection for edit modal (internal communities)
    if (activeCommunity?.is_internal && internalCommunityMembers.length > 0 && editInputRef.current) {
      const cursorPosition = editInputRef.current.selectionStart || newValue.length
      const textBeforeCursor = newValue.substring(0, cursorPosition)
      const lastAtIndex = textBeforeCursor.lastIndexOf('@')

      if (lastAtIndex !== -1) {
        const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1)
        const charAfterAt = newValue.charAt(lastAtIndex + 1)
        const hasMultipleAt = charAfterAt === '@' || textAfterAt.startsWith('@')
        const hasInvalidChar = REG_EX.MENTION_INVALID_CHAR.test(textAfterAt) || hasMultipleAt

        if (!hasInvalidChar) {
          const searchTerm = textAfterAt.trim().toLowerCase()

          setEditMentionSearchTerm(searchTerm)
          setEditMentionStartPosition(lastAtIndex)
          setShowEditMentionDropdown(true)
          setSelectedEditMentionIndex(0)
        } else {
          setShowEditMentionDropdown(false)
          setEditMentionSearchTerm('')
          setEditMentionStartPosition(null)
        }
      } else {
        setShowEditMentionDropdown(false)
        setEditMentionSearchTerm('')
        setEditMentionStartPosition(null)
      }
    } else {
      setShowEditMentionDropdown(false)
      setEditMentionSearchTerm('')
      setEditMentionStartPosition(null)
    }
  }

  const footerContent = () => {
    if (modalAction === 'edit') {
      return (
        <div className="input-area">
          <div className="edit-container">
            <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png" alt="coffee-web-logo" className="input-logo" />

            <div style={{ position: 'relative', width: '100%', flex: 1 }}>
              <InputTextarea
                ref={(el) => {
                  editInputRef.current = el
                  if (el) {
                    textMethods.autoResizeTextarea(el)
                  }
                }}
                rows={isWebView ? 1 : 2}
                cols={1}
                value={editValue}
                onKeyDown={(e) => handleEditKeyDown(e)}
                onChange={(e) => handleEditChange(e.target.value)}
                placeholder={`${placeholderText()}...`}
                className="edit-input-field"
              />

              {showEditMentionDropdown &&
                activeCommunity?.is_internal &&
                internalCommunityMembers.length > 0 &&
                (() => {
                  const { members: filteredMembers } = getFilteredEditMentionMembers()

                  if (filteredMembers.length === 0) return null

                  return <MentionDropdown members={filteredMembers} selectedIndex={selectedEditMentionIndex} onSelect={insertEditMention} onHover={setSelectedEditMentionIndex} />
                })()}
            </div>
          </div>
          <Button rounded icon="pi pi-send send-icon" disabled={!editValue.trim()} className={`send-button ${!editValue.trim() ? 'disabled-btn' : ''} `} onClick={handleModalConfirm} />
        </div>
      )
    }
    if (modalAction === 'reportAbuse') {
      return (
        <div className="confirmation-modal-buttons">
          <Button label="Cancel" className="confirmation-no-button" onClick={() => setConfirmationModal(false)} disabled={isReporting} />
          <Button
            label="Report"
            className="confirmation-yes-button"
            onClick={async () => {
              await handleReportAbuse(modalMessage)
              setConfirmationModal(false)
              setModalAction(null)
              setModalMessage(null)
              setSelectedReportReason(null)
            }}
            disabled={!selectedReportReason || isReporting}
          />
        </div>
      )
    }

    return (
      <div className="confirmation-modal-buttons">
        <Button label="No" className="confirmation-no-button" onClick={() => setConfirmationModal(false)} />
        <Button label="Yes" className="confirmation-yes-button" onClick={handleModalConfirm} />
      </div>
    )
  }

  // commented if chat scroll through cursor
  // useEffect(() => {
  //   nextCursorRef.current = nextCursor
  // }, [nextCursor])

  useEffect(() => {
    const container = containerRef.current

    if (!container) return

    const handleScroll = () => {
      if (container.scrollTop <= 60 && !isFetchingRef.current && hasMoreRef.current && activeCommunity?.id) {
        fetchOlderChats(activeCommunity.id)
      }
    }

    container.addEventListener('scroll', handleScroll)

    return () => container.removeEventListener('scroll', handleScroll)
  }, [activeCommunity?.id]) // rebind only when switching rooms

  // Fetch report reasons when reportAbuse modal opens
  useEffect(() => {
    if (confirmationModal && modalAction === 'reportAbuse') {
      setReportReasons([])
      setSelectedReportReason(null)
      getReportReasons()
        .then((res) => {
          setReportReasons(res?.data?.reasons || [])
        })
        .catch(() => setReportReasons([]))
    }
  }, [confirmationModal, modalAction])

  // Keep activeCommunityIdRef in sync - used by fetchOlderChats to avoid stale closure
  useEffect(() => {
    activeCommunityIdRef.current = activeCommunity?.id ?? null
  }, [activeCommunity?.id])

  useEffect(() => {
    if (!activeCommunity?.id || activeCommunity?.isCreateOwn || activeCommunity?.isUrlApproval || activeCommunity?.isYourNews) return
    isInitialLoadRef.current = true
    hasMoreRef.current = true
    nextCursorRef.current = null
    existingIdsRef.current = new Set()
    earliestTimestampRef.current = null
    isFetchingRef.current = false // Allow new fetch to start (old fetch will be ignored via ref check)
    setChats([])
    setRepliedMessage(null)
    fetchOlderChats(activeCommunity.id)
  }, [activeCommunity?.id])

  // When switching back from Personal Chats tab to Communities tab, the scrollbar should come to the bottom
  useEffect(() => {
    if (prevActiveTabRef.current === 'personalChats' && activeTab === 'communities') {
      if (activeCommunity?.id && !activeCommunity?.isCreateOwn && !activeCommunity?.isUrlApproval && !activeCommunity?.isYourNews) {
        requestAnimationFrame(() => {
          scrollToBottom(true)
        })
      }
    }

    prevActiveTabRef.current = activeTab
  }, [activeTab, activeCommunity?.id])

  // Sync selectedCommunityId with activeCommunity when in CoffeePostScreen mode
  useEffect(() => {
    if (isCoffeePost && selectedCommunityId) {
      // Find the community from filteredGroupList and set it as active
      const community = filteredGroupList.find((c) => String(c.id) === String(selectedCommunityId))

      if (community && String(community.id) !== String(activeId)) {
        // Update ref immediately so any in-flight fetch sees new community and ignores its response
        activeCommunityIdRef.current = community.id
        setActiveCommunity(community)
        setActiveId(community.id)
        updateCommunitySearchParam(community.id)
        // Reset chat state
        isInitialLoadRef.current = true
        hasMoreRef.current = true
        nextCursorRef.current = null
        earliestTimestampRef.current = null
        existingIdsRef.current = new Set()
        isFetchingRef.current = false
        setChats([])
        setValue('')
        setRepliedMessage(null)
        setAttachments([])
        setUserRoleInCommunity(null)
        setPendingUrlMessages([])
        setPendingUrlsError(null)
      }
    } else if (isCoffeePost && !selectedCommunityId && activeId) {
      // Reset when going back to communities list
      activeCommunityIdRef.current = null
      setActiveCommunity(null)
      setActiveId('')
      setChats([])
      setValue('')
      setRepliedMessage(null)
      setAttachments([])
    }
  }, [selectedCommunityId, isCoffeePost, filteredGroupList, activeId])

  const formatTime = React.useCallback(
    (ts) => {
      // This handles the case for Guest User and Logged-in User
      const use12h = userDetails?.id ? userDetails.userTimeFormat.startsWith('12') : false

      return timeMethods.UtcToLocalTimeFn(ts, use12h)
    },
    [userDetails?.id, userDetails?.userTimeFormat]
  )

  // Helper function to generate MessageMenu props
  const getMessageMenuProps = (msg, isOutgoing, attachmentIndexForEdit = null, messageTimestamp = null) => ({
    placement: isOutgoing ? 'bottom-end' : 'bottom-start',
    onReply: () => handleReply(msg, setRepliedMessage, repliedMsgRef, inputRef, attachmentIndexForEdit),
    onCopy: () => navigator.clipboard?.writeText(msg.content).catch(() => {}),
    onReact: () => {},
    onForward: () => openForwardModal(msg),
    onPin: () => {},
    onStar: () => {},
    onAddNote: () => {},
    onReport: () => {},
    onEdit: () => openConfirmationModal('edit', msg, attachmentIndexForEdit),
    onDeleteForMe: () => openConfirmationModal('deleteForMe', msg, attachmentIndexForEdit),
    onDeleteForEveryone: () => openConfirmationModal('deleteForEveryone', msg, attachmentIndexForEdit),
    onDeleteMessageByAdmin: () => openConfirmationModal('deleteMessageByAdmin', msg),
    onDeleteAllMessageByAdmin: () => openConfirmationModal('deleteAllMessageByAdmin', msg),
    onBlockUserByAdmin: () => openConfirmationModal('blockUserByAdmin', msg),
    onReportAbuse: () => openConfirmationModal('reportAbuse', msg),
    onUndoReportAbuse: !isOutgoing ? () => handleUndoReportAbuse(msg) : undefined,
    onChatPersonally: !isOutgoing ? () => handleChatPersonally(msg) : undefined,
    isReportedByMe: msg.is_reported_by_me,
    isActionAllowed: isOutgoing,
    isAdminUser,
    reportAbuseOption: msg?.user?.can_act_as_bot,
    isOwnMessage: isOutgoing,
    hasAttachments: isOutgoing ? (msg?.attachments?.length && msg?.attachments[attachmentIndexForEdit]?.caption) || msg?.content : false,
    isPendingApproval: msg?.has_url && msg?.approved_status === 'PENDING',
    allowPersonalChat: !isOutgoing ? msg?.user_info?.allow_personal_chat === true && isPersonalChatAvailable : undefined,
    allowedDuration: isOutgoing ? 5 * 60 * 1000 : undefined,
    messageTime: isOutgoing ? messageTimestamp : undefined,
    hasUrl: msg?.has_url
  })

  const fetchOlderChats = async (communityId) => {
    if (isFetchingRef.current) return
    if (activeCommunity?.isCreateOwn || activeCommunity?.isUrlApproval || activeCommunity?.isYourNews) return
    if (!communityId) return

    isFetchingRef.current = true
    setIsFetchingOlder(true)

    const container = containerRef.current
    const prevScrollHeight = container ? container.scrollHeight : 0
    const prevScrollTop = container ? container.scrollTop : 0

    try {
      const isInitialLoad = isInitialLoadRef.current || existingIdsRef.current.size === 0
      const offset = existingIdsRef.current.size

      const { data: attachmentMessages, error } = await getCommunityMessagesWithAttachments({
        p_community_id: communityId,
        p_user_id: userDetails?.id || 0,
        p_limit: PAGE_SIZE,
        p_offset: offset
      })

      if (error) {
        hasMoreRef.current = false

        return
      }

      // Filter out messages already in chat and deleted messages
      // Also filter based on approval status: pending URL messages only show to sender
      const newMessages = attachmentMessages?.messages?.filter((msg) => {
        if (existingIdsRef.current.has(String(msg.id))) return false
        if (msg.deleted_at !== null) return false
        if (msg.deleted_for_users && msg.deleted_for_users.includes(userDetails?.id)) return false

        // Filter based on approval status
        // If message has URL and is pending, only show to sender
        if (msg?.has_url && msg?.approved_status === 'PENDING') {
          return msg?.userid === userDetails?.id
        }

        return true
      })

      if (!newMessages?.length) {
        hasMoreRef.current = attachmentMessages?.messages?.length === PAGE_SIZE

        return
      }

      // Check against ref (not closure) - avoids stale closure when old fetch completes after switch
      if (String(activeCommunityIdRef.current) !== String(communityId)) {
        // Community was switched, ignore this response
        return
      }

      // Update refs
      newMessages.forEach((msg) => {
        existingIdsRef.current.add(String(msg.id))
      })

      // Sort chronologically
      const sortedMessages = newMessages.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))

      // ========== ADD REPLY USER FETCHING LOGIC ==========

      // Get unique reply user IDs that need user info
      const replyUserIds = [
        ...new Set(
          sortedMessages
            .filter((m) => m.reply_to_id)
            .map((m) => m.reply_user_id)
            .filter(Boolean)
        )
      ]

      // Fetch reply user info in parallel
      const replyUsersMap = {}

      if (replyUserIds.length) {
        const replyUserFetches = await Promise.all(replyUserIds.map((userId) => fetchOlderMessages(userId)))

        replyUserFetches.forEach((r) => {
          if (r?.data) {
            replyUsersMap[r.data.userid] = r.data
          }
        })
      }

      // ========== BUILD MESSAGES WITH REPLIES AND ATTACHMENT CHECK ==========

      // Helper function to fetch URL metadata
      const fetchUrlPreview = async (url) => {
        try {
          const response = await getURLMetadata(url)

          const urlMetaData = response?.data

          if (response && (urlMetaData.title || urlMetaData.description || urlMetaData.image)) {
            const domain = urlMethods.extractDomainFromUrl(url)
            const title = urlMetaData.title && urlMetaData.title !== url ? urlMetaData.title : domain

            return {
              title: title || domain,
              description: urlMetaData.description || '',
              image: urlMetaData.image || '',
              url,
              siteName: urlMetaData.siteName || domain
            }
          }
        } catch (err) {
          console.error('Error fetching URL preview:', err)
        }

        return null
      }

      // Identify messages that need URL previews
      const messagesNeedingPreview = sortedMessages.filter((msg) => msg.has_url && !msg.url_preview)

      // Fetch previews in parallel
      const previewPromises = messagesNeedingPreview.map(async (msg) => {
        const firstUrl = urlMethods.getFirstUrl(msg.content || '')

        if (firstUrl) {
          const preview = await fetchUrlPreview(firstUrl)

          return { messageId: msg.id, preview }
        }

        return { messageId: msg.id, preview: null }
      })

      const previewResults = await Promise.all(previewPromises)
      const previewMap = {}

      previewResults.forEach(({ messageId, preview }) => {
        if (preview) {
          previewMap[messageId] = preview
        }
      })

      // Enhance user_info with allow_personal_chat if missing
      // Get unique user IDs from messages that need allow_personal_chat
      const userIdsNeedingEnhancement = [
        ...new Set(
          sortedMessages
            .filter((m) => m.userid && m.user_info && m.user_info.allow_personal_chat === undefined)
            .map((m) => m.userid)
            .filter(Boolean)
        )
      ]

      // Fetch allow_personal_chat for users that need it
      const userAllowPersonalChatMap = {}

      if (userIdsNeedingEnhancement.length) {
        const userFetches = await Promise.all(userIdsNeedingEnhancement.map((userId) => getUserAllowPersonalChat(userId)))

        userFetches.forEach((r) => {
          if (r?.data) {
            userAllowPersonalChatMap[r.data.userid] = r.data.allow_personal_chat
          }
        })
      }

      const messagesWithReplies = await Promise.all(
        sortedMessages.map(async (msg) => {
          // Enhance user_info with allow_personal_chat if missing
          let enhancedMsg = msg

          if (msg.userid && msg.user_info && userAllowPersonalChatMap[msg.userid] !== undefined) {
            enhancedMsg = {
              ...msg,
              user_info: {
                ...msg.user_info,
                allow_personal_chat: userAllowPersonalChatMap[msg.userid]
              }
            }
          }

          let repliedMessage = null

          // Check if the replied message has an attachment (using reply_to_id)
          if (enhancedMsg.reply_to_id) {
            const replyMessage = await getMessageHasAttachmentsById(enhancedMsg.reply_to_id)

            const { data: attachments, error: attachmentErrors } = await getMessageAttachmentMediaTypesByMessageId(enhancedMsg.reply_to_id)

            let hasAttachment = false
            let attachmentsCount = 0
            let firstAttachmentType = null

            if (attachments && attachments.length > 0) {
              hasAttachment = true
              attachmentsCount = attachments.length
              firstAttachmentType = attachments[0].media_type // first occurrence
            }

            if (replyMessage?.data?.has_attachments) {
              hasAttachment = true
            }

            if (enhancedMsg.is_reply_deleted) {
              const replyUser = replyUsersMap[enhancedMsg.reply_user_id]

              repliedMessage = {
                id: enhancedMsg.reply_to_id,
                content: null, // This will trigger "Message deleted" in UI
                user: replyUser || userMethods.createDefaultUser(enhancedMsg.reply_user_id),
                userid: enhancedMsg.reply_user_id,
                hasAttachment,
                attachmentsType: firstAttachmentType
              }
            } else {
              const replyUser = replyUsersMap[enhancedMsg.reply_user_id]

              repliedMessage = {
                id: enhancedMsg.reply_to_id,
                content: enhancedMsg.is_reply_deleted ? null : enhancedMsg.reply_content,
                userid: enhancedMsg.reply_user_id,
                user: replyUser || userMethods.createDefaultUser(enhancedMsg.reply_user_id),
                hasAttachment,
                attachmentsCount,
                attachmentsType: firstAttachmentType
              }
            }
          }

          return {
            ...enhancedMsg,
            repliedMessage,
            url_preview: enhancedMsg.url_preview || previewMap[enhancedMsg.id] || null
          }
        })
      )

      // ========== REST OF YOUR EXISTING LOGIC ==========

      // Check against ref (not closure) - avoids stale closure when old fetch completes after switch
      if (String(activeCommunityIdRef.current) !== String(communityId)) {
        // Community was switched, ignore this response
        return
      }

      if (isInitialLoad) {
        setChats((prevOptimistic) => {
          const optimistic = prevOptimistic.filter((p) => !p.id)

          return [...messagesWithReplies, ...optimistic]
        })
        isInitialLoadRef.current = false

        // Always scroll to the latest message after the initial load for a community
        requestAnimationFrame(() => {
          if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight
          }
        })
      } else {
        setChats((prev) => [...messagesWithReplies, ...prev])

        requestAnimationFrame(() => {
          if (!containerRef.current) return
          const newScrollHeight = containerRef.current.scrollHeight
          const delta = newScrollHeight - prevScrollHeight

          containerRef.current.scrollTop = prevScrollTop + delta
        })
      }

      hasMoreRef.current = attachmentMessages?.messages?.length === PAGE_SIZE

      // Reset unread count when opening community
      if (activeCommunity?.unread_count > 0 || !('unread_count' in activeCommunity)) {
        await supabase
          .from('community_members')
          .update({
            unread_count: 0,
            last_read_timestamp: new Date().toISOString()
          })
          .eq('userid', userDetails?.id)
          .eq('community_id', communityId)
        onUnreadCountRefresh?.()
        if (!isCoffeePost) {
          fetchUnreadCounts()
        }
      }
    } catch (err) {
      console.error('[fetchOlderChats] unexpected error', err)
    } finally {
      isFetchingRef.current = false
      // Only clear loading if this fetch was for the current community (avoid old fetch hiding loader)
      if (String(activeCommunityIdRef.current) === String(communityId)) {
        setIsFetchingOlder(false)
      }
    }
  }

  const handleFetchInternalCommunityMembers = async (communityId) => {
    const members = await fetchInternalCommunityMembers(communityId)

    setInternalCommunityMembers(members)
  }

  const imgUrl = 'https://coffeeweb.s3.ap-south-1.amazonaws.com/coffeeweb_menu_icons/CoffeeWeb_Logo_White_Background_Blue_Text.png'
  const newsTitle = 'CoffeeWeb Community'
  const shareLinksFowWhatsApp = 'Link'
  const newsTitleForWhatsApp = 'Coffee Communities'

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    getAllGroupsList()
  }, [userDetails?.id])

  const atBottomRef = useRef(true)
  const BOTTOM_EPS = 24

  const [showScrollButton, setShowScrollButton] = useState(false) // UI state

  useEffect(() => {
    const el = containerRef.current

    if (!el) return
    const onScroll = () => {
      const distance = el.scrollHeight - (el.scrollTop + el.clientHeight)

      const isAtBottom = distance < BOTTOM_EPS

      atBottomRef.current = isAtBottom
      setShowScrollButton(!isAtBottom)

      if (isAtBottom) setUnreadCount(0)
    }

    el.addEventListener('scroll', onScroll)
    // initialize once
    onScroll()

    return () => el.removeEventListener('scroll', onScroll)
  }, [activeCommunity?.id])

  useEffect(() => {
    const el = containerRef.current

    if (!el || !atBottomRef.current || isFetchingRef.current || isFetchingOlder) return

    // wait for commit + layout
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
      })
    })
  }, [chats.length, isFetchingOlder]) // only when a row is added/removed

  // ============ Fetch Real Time Data ============
  // Sort communities by last message/activity descending (newest first). Use for "newer message at top" order.
  const sortCommunitiesByNewestFirst = (items) =>
    [...items].sort((a, b) => {
      const aTime = new Date(a.last_message_at || 0).getTime()
      const bTime = new Date(b.last_message_at || 0).getTime()

      return bTime - aTime
    })

  // Reorder list so the community with communityId is at top (after URL approval if present). Optional unreadCount to set on that item.
  const moveCommunityToTop = useCallback(
    (communityId) => {
      if (!communityId) return
      const reorderPutFirst = (list) => {
        if (!Array.isArray(list) || list.length === 0) return list

        const urlApproval = list.filter((x) => x?.isUrlApproval)
        const createOwn = list.filter((x) => x?.isCreateOwn)
        const rest = list.filter((x) => !x?.isUrlApproval && !x?.isCreateOwn)
        const moveIdx = rest.findIndex((x) => String(x.id) === String(communityId))

        if (moveIdx < 0) return list
        const [item] = rest.splice(moveIdx, 1)
        // Newest at top: moved community first, then rest sorted by last message/activity (newer first)
        const restNewestFirst = sortCommunitiesByNewestFirst(rest)

        return [...urlApproval, item, ...restNewestFirst, ...createOwn]
      }

      setGroupList((prev) => reorderPutFirst(prev))
      setFilteredGroupList((prev) => reorderPutFirst(prev))
    },
    [userDetails?.id]
  )

  useEffect(() => {
    if (!userDetails?.id) return

    return subscribeToRealTimeCommunityUpdates(userDetails.id, handleRealTimeCommunities)
  }, [userDetails?.id])

  // Keep ref in sync for use inside message-INSERT callback
  useEffect(() => {
    groupListRef.current = groupList
  }, [groupList])

  const communityIdsForRealtime = React.useMemo(
    () =>
      groupList
        ?.filter((g) => !g?.isCreateOwn && !g?.isUrlApproval && !g?.isYourNews && g?.id)
        ?.map((g) => String(g.id))
        ?.filter(Boolean)
        ?.sort()
        ?.join(','),
    [groupList]
  )

  useEffect(() => {
    if (!userDetails?.id || !communityIdsForRealtime) return

    const ids = communityIdsForRealtime.split(',').filter(Boolean)

    if (!ids.length) return

    const unsubscribe = subscribeToRealTimeCommunityMessageToTop(ids, moveCommunityToTop)

    return unsubscribe
  }, [communityIdsForRealtime, userDetails?.id, moveCommunityToTop])

  useEffect(() => {
    if (!activeCommunity?.id || activeCommunity?.isCreateOwn || activeCommunity?.isUrlApproval || activeCommunity?.isYourNews) return

    const unsubscribe = subscribeToRealtimeCommunity(activeCommunity.id, handleRealtimeMessage, activeCommunityIdRef, setChats, getCommunityMessagesWithAttachments, userDetails?.id, activeCommunity)

    setUnreadCount(0)

    return unsubscribe
  }, [activeCommunity?.id])

  useEffect(() => {
    if (!userDetails?.id || !activeCommunity?.id || activeCommunity?.isCreateOwn || activeCommunity?.isUrlApproval || activeCommunity?.isYourNews) return

    checkBlockedStatus()
    checkUserRole()

    return subscribeToRealTimeBlockCommunityMember(activeCommunity.id, handleRealTimeBlockStatus)
  }, [activeCommunity?.id, userDetails?.id])

  const fetchHistory = async (communityData) => {
    setDataLoading(true)
    try {
      const { success, history } = await getNewsReminderHistory(communityData?.id, userDetails?.id, 50, 0)

      const entries = success && Array.isArray(history) ? history : []

      setSelectedHistoryEntries(entries)
    } catch {
      setDataLoading(false)
    } finally {
      setDataLoading(false)
    }
  }

  const fetchReminders = async (reminder) => {
    try {
      const { reminders: list } = await getUserNewsReminders(userDetails?.id)

      const selectedReminder = list?.find((r) => r?.id === reminder?.id) || null

      setReminders(selectedReminder)
    } catch {
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  function handleRealTimeCommunities(payload) {
    const communitiesData = payload.new

    setFilteredGroupList((prev) =>
      prev.map((item) =>
        String(item.id) === String(communitiesData.community_id)
          ? { ...item, unread_count: communitiesData.unread_count ?? 0 } // only update the matched one
          : item
      )
    )
    setGroupList((prev) =>
      prev.map((item) =>
        String(item.id) === String(communitiesData.community_id)
          ? { ...item, unread_count: communitiesData.unread_count ?? 0 } // only update the matched one
          : item
      )
    )

    setActiveCommunity((prev) => (prev && String(prev.id) === String(communitiesData.community_id) ? { ...prev, unread_count: communitiesData.unread_count ?? 0 } : prev))
  }

  // Realtime handler for new messages
  async function handleRealtimeMessage(message) {
    // Use ref to avoid stale closure - verify message belongs to current active community
    if (!activeCommunityIdRef.current || String(message.community_id) !== String(activeCommunityIdRef.current)) {
      return
    }

    const userId = message.userid

    const { data: user, error } = await getUserForCommunityRealtimeMessage(userId)

    // Fetch attachments - with retry logic if has_attachments is true
    let attachments = []

    if (message.has_attachments) {
      // Add a small delay to ensure attachments are written to DB
      await new Promise((resolve) => {
        setTimeout(resolve, 100)
      })

      const { data: attachmentsData, error: attError } = await supabase
        .from('message_attachments')
        .select('*')
        .eq('message_id', message.id)
        .eq('is_visible', true) // filter by visible attachments
        .order('sort_order', { ascending: true })
        .order('created_at', { ascending: true })

      if (!attError && attachmentsData) {
        attachments = attachmentsData
      } else {
        console.warn('Error fetching attachments:', attError)
      }
    }

    // Do not mutate the function parameter `message`; create a new object instead
    const msg = { ...message, attachments }

    if (error) {
      console.error('Error fetching user:', error)

      return
    }

    let replied = null

    if (msg.reply_to_id) {
      const { data: rep, error: repErr } = await getMessageReplyWithUser(msg.reply_to_id)

      if (repErr || !rep) {
        console.warn('Replied message not found for id', msg.reply_to_id, repErr)
      } else {
        let attachmentsCount = 0
        let firstAttachmentType = null
        const hasAttachment = !!rep.has_attachments

        if (hasAttachment) {
          // small delay ensures DB consistency
          // eslint-disable-next-line
          await new Promise((resolve) => setTimeout(resolve, 100))

          const { data: attData, error: attErr } = await getMessageAttachmentMediaTypesByMessageId(rep.id)

          if (!attErr && attData && attData.length > 0) {
            attachmentsCount = attData.length
            firstAttachmentType = attData[0].media_type
          } else if (attErr) {
            console.warn('Error fetching replied message attachments:', attErr)
          }
        }

        // Build repliedMessage with attachment info
        replied = {
          ...rep,
          hasAttachment,
          attachmentsCount,
          attachmentsType: firstAttachmentType
        }
      }
    }

    // Fetch URL preview if message has URL but no preview metadata
    let urlPreview = null

    if (msg.has_url && !msg.url_preview) {
      const firstUrl = urlMethods.getFirstUrl(msg.content || '')

      if (firstUrl) {
        try {
          const response = await new Promise((resolve, reject) => {
            getURLMetadata(firstUrl, (err, data) => {
              if (err) reject(err)
              else resolve(data)
            })
          })

          // The callback receives response.data directly, so response IS the data object
          if (response && (response.title || response.description || response.image)) {
            const data = response
            // Extract domain helper

            const domain = urlMethods.extractDomainFromUrl(firstUrl)

            // If title is the URL itself, use domain as title, otherwise use the title
            const title = data.title && data.title !== firstUrl ? data.title : domain

            urlPreview = {
              title: title || domain,
              description: data.description || '',
              image: data.image || '',
              url: firstUrl,
              siteName: data.siteName || domain
            }
          }
        } catch (err) {
          console.error('Error fetching URL preview for real-time message:', err)
        }
      }
    }

    const fullMessage = {
      ...msg,
      user_info: user,
      repliedMessage: replied, // may be null
      url_preview: msg.url_preview || urlPreview || null,
      url_preview_url: msg.url_preview_url || urlMethods.getFirstUrl(msg.content || '') || null
    }

    // Filter messages based on approval status
    // If message has URL and is pending, only show to sender
    const shouldShowMessage =
      fullMessage?.userid === userDetails?.id || // Always show sender's own messages
      !(fullMessage?.has_url && fullMessage?.approved_status === 'PENDING') // Show if not pending URL message

    if (shouldShowMessage) {
      // Re-check ref before updating - user may have switched communities during async work
      if (String(fullMessage.community_id) !== String(activeCommunityIdRef.current)) {
        return
      }

      // Check if message already exists (to avoid duplicates)
      setChats((prev) => {
        // Guard: user may have switched communities - ref is authoritative
        if (String(fullMessage.community_id) !== String(activeCommunityIdRef.current)) {
          return prev
        }
        // First check if message with this ID already exists
        const existingIndex = prev.findIndex((m) => m.id === fullMessage.id)

        if (existingIndex >= 0) return prev

        // If this is our own message (sent by current user), check for optimistic message with tempId
        // that we need to replace. This handles the race condition where real-time INSERT fires
        // before postChatMessage() can replace the optimistic message
        if (fullMessage?.userid === userDetails?.id) {
          // Find optimistic message (has tempId-like structure or pending flag)
          // Also check for forwarded messages with forward-temp- IDs
          const optimisticIndex = prev.findIndex((m) => {
            // Check for regular temp messages
            if ((m.pending && m.community_id === fullMessage.community_id) || (typeof m.id === 'string' && m.id.startsWith('temp-') && m.community_id === fullMessage.community_id && m.userid === fullMessage.userid)) {
              return true
            }
            // Check for forwarded messages with forward-temp- IDs
            // Match by: same user, same community, same content, and is_forwarded flag
            if (typeof m.id === 'string' && m.id.startsWith('forward-temp-') && m.community_id === fullMessage.community_id && m.userid === fullMessage.userid && m.is_forwarded === true && fullMessage.is_forwarded === true && m.content === fullMessage.content) {
              return true
            }

            return false
          })

          if (optimisticIndex >= 0) {
            // Replace optimistic message with real one
            const newChats = [...prev]

            newChats[optimisticIndex] = { ...fullMessage, pending: false }

            return newChats
          }
        }

        // Message doesn't exist, add it

        return [...prev, fullMessage]
      })

      // Only increment unread count if message is from another user and we're not at bottom
      if (fullMessage?.userid !== userDetails?.id && !atBottomRef.current) {
        setUnreadCount((prev) => prev + 1)
      }
    }

    moveCommunityToTop(fullMessage?.community_id)

    await supabase
      .from('community_members')
      .update({
        unread_count: 0,
        last_read_timestamp: new Date().toISOString()
      })
      .eq('userid', userDetails?.id)
      .eq('community_id', activeId)
  }

  function handleRealTimeBlockStatus(payload) {
    const blockedStatus = payload.new

    // Check if blocked changed to true
    if (blockedStatus?.userid === userDetails?.id && blockedStatus?.blocked) {
      setIsBlocked(true)
    } else if (blockedStatus?.userid === userDetails?.id && !blockedStatus?.blocked) {
      setIsBlocked(false)
    }

    // Update role if it changed
    if (blockedStatus?.userid === userDetails?.id && blockedStatus?.role !== undefined) {
      setUserRoleInCommunity(blockedStatus.role)
    }
  }

  const checkBlockedStatus = async () => {
    try {
      const { data } = await getCommunityMemberBlocked(activeCommunity.id, userDetails.id)

      setIsBlocked(data?.blocked === true)
    } catch (error) {
      console.log('Error Checking blocked status', error)
    }
  }

  const checkUserRole = async () => {
    try {
      const { data } = await getCommunityUserRole(activeCommunity?.id, userDetails?.id)

      setUserRoleInCommunity(data?.role || null)
    } catch (error) {
      setUserRoleInCommunity(null)
    }
  }

  const init = async () => {
    const getAllShareListResponse = await apiAdapterCoffeeWeb.getAllShareList()
    // const getShortUrl = apiAdapterCoffeeWeb.shortenUrl(shareUrl)

    try {
      //   const [getAllShareListResponse, getShortUrlResponse] = await Promise.all([getAllShareList, getShortUrl])

      const activeSocialMediaListNames = getAllShareListResponse.data?.returnLst?.map((ele) => ele.shareName)

      //   setIsModalVisible(true)
      setActiveSocialMediaLists(activeSocialMediaListNames)
      //   setShortenUrl(getShortUrlResponse.data)
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoading(false)
    }
  }

  const getAllGroupsList = async (options = {}) => {
    const { skipActiveCommunityUpdate } = options

    try {
      // Determine if the current user is an admin (can act as bot)
      let isAdmin = false

      if (userDetails?.id) {
        try {
          const { data } = await getCanActAsBot(userDetails?.id)

          isAdmin = !!data?.can_act_as_bot
          setIsAdminUser(isAdmin)
        } catch (err) {
          setIsAdminUser(false)
        }
      } else {
        setIsAdminUser(false)
      }

      const { data: response } = await fetchUserDetailsFromSupabase(userDetails?.id)

      const isInternalUser = response?.is_internal_user

      const isBot = response?.can_act_as_bot

      let groupListResponse = []

      let internalGroupList = []

      if (isBot) {
        const [internalData, communityData] = await Promise.all([getInternalUserCommunities({ p_userid: userDetails?.id || 0 }), userDetails ? getUserCommunities({ p_userid: userDetails?.id }) : getGuestUserCommunities({ p_country_id: 0 })])

        internalGroupList = internalData || []
        groupListResponse = communityData || []
      } else if (isInternalUser) {
        internalGroupList = await getInternalUserCommunities({ p_userid: userDetails?.id || 0 })
      } else {
        groupListResponse = userDetails ? await getUserCommunities({ p_userid: userDetails?.id }) : await getGuestUserCommunities({ p_country_id: 0 })
      }

      const { data, error } = await getCommunityMembersUnreadCounts(userDetails?.id)

      const communityIds = groupListResponse.data?.map((item) => item.id)

      await addUserToCommunity({ userid: userDetails?.id, community_ids: communityIds })

      const combinedGroupList = [...(groupListResponse.data || []), ...(internalGroupList.data || [])]

      const modifiedGroupList = combinedGroupList.map((item1) => {
        const match = data?.find((item2) => item2.community_id === item1.id)

        return {
          ...item1,
          unread_count: match ? match.unread_count : 0
        }
      })

      // Always "newer message at top": prefer order by last message/activity (newest first); fallback to sort_order if no timestamps
      const hasLastActivity = modifiedGroupList.some((g) => g?.last_message_at != null || g?.last_activity_at != null)

      if (hasLastActivity) {
        modifiedGroupList.sort((a, b) => {
          const aTime = new Date(a.last_message_at || 0).getTime()
          const bTime = new Date(b.last_message_at || 0).getTime()

          return bTime - aTime
        })
      }

      let finalList = [...modifiedGroupList]

      if (userDetails?.id) {
        try {
          const { success: hasYourNews, reminder } = await getLastScheduledYourNews(userDetails?.id)

          if (hasYourNews && reminder?.id && reminder?.title) {
            const yourNewsActivityTime = reminder.scheduled_for || null

            const yourNewsCommunity = {
              id: reminder.id,
              name: reminder.title,
              community_url: 'https://coffeeweb.s3.ap-south-1.amazonaws.com/your_news.png',
              subscription_details: [
                {
                  subscription_code: 'R',
                  subscription_name: 'Regular',
                  subscription_colors: ['#50b3f6', '#8DD5F4', '#50b3f6']
                },
                {
                  subscription_code: 'G',
                  subscription_name: 'Gold',
                  subscription_colors: ['#a48011', '#e7cd77', '#a48011']
                },
                {
                  subscription_code: 'P',
                  subscription_name: 'Platinum',
                  subscription_colors: ['#8A8A8A', '#D4D4D4', '#8A8A8A']
                }
              ],
              isYourNews: true,
              isCreateOwn: false,
              isUrlApproval: false,
              unread_count: reminder.unread_count,
              yourNewsReminderId: reminder.id,
              yourNewsReminderTime: yourNewsActivityTime,
              last_message_at: yourNewsActivityTime
            }

            finalList = sortCommunitiesByNewestFirst([...finalList, yourNewsCommunity])
          }

          fetchHistory(reminder)
          fetchReminders(reminder)
        } catch (e) {
          console.log(e)
        }
      }

      // Fetch settings for "Create Your Own Community"
      const { data: settingsData } = await getKvAppSetting()

      const createCount = Number(settingsData?.create_community_count) || 0
      const instructions = settingsData?.community_instructions?.instructions || []

      setCreateCommunityInstructions(instructions)

      let extraCommunities = []

      if (createCount > 0) {
        extraCommunities = Array.from({ length: createCount }, (_, idx) => ({
          id: `create-own-${idx + 1}`,
          name: 'Create Your Own Community',
          community_url: '',
          subscription_details: [],
          isCreateOwn: true,
          instructions
        }))
      }

      let finalListWithExtras = [...finalList, ...extraCommunities]

      // Inject hardcoded admin-only "URL Approval" community at the top
      if (isAdmin) {
        const urlApprovalCommunity = {
          id: 'url-approval',
          name: 'CoffeeWeb Link Approval',
          community_url: 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png',
          subscription_details: [],
          isUrlApproval: true,
          isCreateOwn: false,
          unread_count: 0
        }

        finalListWithExtras = [urlApprovalCommunity, ...finalListWithExtras]
      }

      const orderedCommunitiesWithExtras = finalListWithExtras

      setGroupList(orderedCommunitiesWithExtras)
      setFilteredGroupList(orderedCommunitiesWithExtras)

      if (skipActiveCommunityUpdate) {
        return
      }

      const params = new URLSearchParams(location.search)
      const requestedCommunityId = params.get('communityId')
      let initialCommunity = null

      if (requestedCommunityId) {
        initialCommunity = orderedCommunitiesWithExtras.find((item) => String(item.id) === requestedCommunityId) || null
      }

      if (!initialCommunity && orderedCommunitiesWithExtras.length > 0) {
        initialCommunity = orderedCommunitiesWithExtras[0]
      }

      if (initialCommunity) {
        setActiveId(initialCommunity.id)
        setActiveCommunity(initialCommunity)
        updateCommunitySearchParam(initialCommunity.id)
      } else {
        setActiveId('')
        setActiveCommunity(null)
        updateCommunitySearchParam(null)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsCommunitiesLoading(false)
    }
  }

  const invite = () => {
    setIsModalVisible(true)
  }

  const uploadToSupabaseStorage = async (file, communityName) => {
    // Validate file size
    if (file.size > MAX_FILE_SIZE) {
      throw new Error(`File exceeds maximum size of ${MAX_FILE_SIZE / (1024 * 1024)}MB`)
    }

    if (file.size === 0) {
      throw new Error('File is empty')
    }

    // Generate file path with folder structure
    const safeCommunityName = attachmentMethods.sanitizeFileName((communityName || '').trim())
    const timestamp = Date.now()
    const sanitizedFileName = attachmentMethods.sanitizeFileName(file.name)
    const uniqueFileName = `${timestamp}_${sanitizedFileName}`
    const filePath = safeCommunityName ? `${safeCommunityName}/${uniqueFileName}` : uniqueFileName

    // Retry logic with Promise.all to handle parallel uploads
    const uploadAttempt = async () => {
      // Use .upload() for all files (Supabase JS SDK handles buffering efficiently)
      const { data, error } = await supabase.storage.from(BUCKET_NAME).upload(filePath, file, {
        cacheControl: '3600',
        upsert: false,
        contentType: file.type || 'application/octet-stream'
      })

      if (error) {
        if (error.message.includes('duplicate') || error.message.includes('already exists')) {
          const { data: retryData, error: retryError } = await supabase.storage.from(BUCKET_NAME).upload(filePath, file, {
            cacheControl: '3600',
            upsert: true,
            contentType: file.type || 'application/octet-stream'
          })

          if (retryError) throw retryError
        } else {
          throw error
        }
      }

      // Get public URL
      const { data: urlData } = supabase.storage.from(BUCKET_NAME).getPublicUrl(filePath)
      const publicUrl = urlData.publicUrl

      return {
        url: publicUrl,
        media_url: publicUrl,
        s3_key: filePath,
        s3_bucket: BUCKET_NAME,
        name: file.name,
        mime: file.type,
        size: file.size
      }
    }

    // Implement retry logic using Promise and recursion instead of loop
    const attemptUpload = async (attemptsLeft) => {
      try {
        return await uploadAttempt()
      } catch (error) {
        if (attemptsLeft <= 1) {
          throw error
        }

        console.warn(`⚠️ Upload attempt failed, ${attemptsLeft - 1} retries remaining:`, error)

        // Create delay promise
        const delay = () =>
          new Promise((resolve) => {
            setTimeout(resolve, RETRY_DELAY)
          })

        // Wait for delay then recursively try again
        await delay()

        return attemptUpload(attemptsLeft - 1)
      }
    }

    // Start recursive retry chain
    try {
      return await attemptUpload(MAX_RETRIES)
    } catch (error) {
      throw error || new Error('Upload failed after maximum retry attempts')
    }
  }

  const onUpdateCaption = (id, { caption }) => {
    setAttachments((prev) => prev.map((att) => (att.id === id ? { ...att, caption } : att)))
  }

  const sendMessage = async () => {
    if (activeCommunity?.isCreateOwn || activeCommunity?.isUrlApproval || activeCommunity?.isYourNews) return

    const trimmedValue = value.trim()
    const hasAttachments = attachments.length > 0

    if ((!trimmedValue && !hasAttachments) || isBlocked) {
      if (isBlocked) setShowBlockedModal(true)

      return
    }

    if (!userDetails?.id) {
      setValue('')
      setAttachments([])
      setRepliedMessage(null)
      setShowRedirectText(true)

      return
    }

    const tempId = `temp-${Date.now()}`
    let uploadedAttachments = []

    // Prepare attachments for optimistic message (using preview URLs)
    const optimisticAttachments = attachments.map((att) => ({
      media_url: att.previewUrl || '',
      mime_type: att.mime || att.file?.type || '',
      file_name: att.name || att.file?.name || '',
      caption: att.caption || '',
      pending: true // Mark as pending for spinner
    }))

    // Detect URLs in message content and attachment captions for optimistic message
    const messageHasUrlOptimistic = urlMethods.hasUrlInMessage(value, attachments)
    const firstUrl = urlMethods.getFirstUrl(value)

    // Create optimistic message with attachments
    const newMessage = {
      id: tempId,
      community_id: `${activeCommunity.id}`,
      userid: userDetails?.id,
      content: value.trim(),
      type: attachments.length ? 'file' : 'text',
      reply_to_id: removeMediaIndex(repliedMessage?.id) || null,
      repliedMessage: repliedMessage || null,
      timestamp: new Date().toISOString(),
      pending: true,
      has_url: messageHasUrlOptimistic,
      approved_status: messageHasUrlOptimistic ? 'PENDING' : null,
      attachments: optimisticAttachments,
      url_preview: inputPreviewMetadata || null, // Include preview metadata if available
      url_preview_url: firstUrl || null,
      user_info: {
        userid: userDetails.id,
        first_name: userDetails.first_name || '',
        last_name: userDetails.last_name || '',
        users_flag_url: userDetails.users_flag_url || ''
      }
    }

    // Immediately clear attachments and show uploading state to switch to chat view
    const attachmentsToUpload = [...attachments]
    const repliedMsgRef = repliedMessage
    const inputValueRef = value

    // Clear state immediately to switch from AttachmentPreview to chat
    setAttachments([])
    setValue('')
    setRepliedMessage(null)
    setIsUploadingImage(true)
    // Keep preview metadata for message, clear after send
    const previewMetadataToKeep = inputPreviewMetadata
    const previewUrlToKeep = inputPreviewUrl

    // Add optimistic message to chat immediately
    setChats((prev) => [...prev, newMessage])

    // Scroll to bottom instantly (no delay) to show the new message immediately
    requestAnimationFrame(() => {
      if (containerRef.current) {
        containerRef.current.scrollTop = containerRef.current.scrollHeight
      }
    })

    try {
      // If has attachments, upload them first
      if (attachmentsToUpload.length) {
        uploadedAttachments = await Promise.all(attachmentsToUpload.map((att) => uploadToSupabaseStorage(att.file, activeCommunity?.name)))
      }

      const attachmentsPayload = uploadedAttachments.map((att, index) => {
        const originalAttachment = attachmentsToUpload[index]

        return {
          caption: originalAttachment.caption || '',
          sort_order: index,
          s3_key: att.s3_key,
          s3_bucket: att.s3_bucket,
          file_name: originalAttachment.file.name,
          file_size: originalAttachment.file.size,
          mime_type: originalAttachment.file.type,
          media_url: att.media_url || att.url, // Use media_url if available, fallback to url
          thumbnail_url: '',
          metadata: {
            uploaded_at: new Date().toISOString(),
            original_file_name: originalAttachment.file.name,
            file_size: originalAttachment.file.size
          }
        }
      })

      // Detect URLs in message content and attachment captions
      const messageHasUrl = urlMethods.hasUrlInMessage(inputValueRef, attachmentsPayload)

      // If preview wasn't loaded before send, try to fetch it now (WhatsApp behavior)
      let finalPreviewMetadata = previewMetadataToKeep

      if (messageHasUrl && !finalPreviewMetadata && previewUrlToKeep) {
        try {
          const response = await new Promise((resolve, reject) => {
            getURLMetadata(previewUrlToKeep, (err, data) => {
              if (err) reject(err)
              else resolve(data)
            })
          })

          // The callback receives response.data directly, so response IS the data object
          if (response && (response.title || response.description || response.image)) {
            const data = response
            // Extract domain helper

            const domain = urlMethods.extractDomainFromUrl(previewUrlToKeep)

            // If title is the URL itself, use domain as title, otherwise use the title
            const title = data.title && data.title !== previewUrlToKeep ? data.title : domain

            finalPreviewMetadata = {
              title: title || domain,
              description: data.description || '',
              image: data.image || '',
              url: previewUrlToKeep,
              siteName: data.siteName || domain
            }
          }
        } catch (err) {
          console.error('Error fetching URL metadata after send:', err)
        }
      }

      // Update message with final preview metadata
      if (finalPreviewMetadata) {
        newMessage.url_preview = finalPreviewMetadata
      }

      // Send message directly
      postChatMessage(newMessage, tempId, attachmentsPayload, messageHasUrl, finalPreviewMetadata)

      // Cleanup: Revoke preview URLs after upload
      if (attachmentsToUpload.length) {
        attachmentsToUpload.forEach((a) => {
          if (a.previewUrl) URL.revokeObjectURL(a.previewUrl)
        })
      }

      // Reset textarea height
      const textAreaRef = inputRef.current

      if (textAreaRef) {
        textAreaRef.style.height = ''
        textAreaRef.style.overflowY = 'hidden'
      }

      // Clear preview state after send
      setInputPreviewUrl(null)
      setInputPreviewMetadata(null)

      // Scroll will be handled by postChatMessage after the message with images is updated
    } catch (err) {
      console.error('Failed to send message:', err)
      // Remove optimistic message on error
      setChats((prev) => prev.filter((msg) => msg.id !== tempId))
      alert('Failed to send message. Please try again.')
    } finally {
      setIsUploadingImage(false)
    }

    // const textAreaRef = inputRef.current

    // if (textAreaRef) {
    //   textAreaRef.style.height = '' // lets CSS min-height take over
    //   textAreaRef.style.overflowY = 'hidden'
    // }
  }

  const handleForwardToCommunity = async (communities) => {
    if (!communities || communities.length === 0) return
    if (!messageToForward) return
    if (!userDetails?.id) {
      setShowRedirectText(true)

      return
    }

    setIsForwarding(true)

    try {
      const forwardPromises = communities.map((community) => {
        const attachmentsPayload = (messageToForward.attachments || []).map((att, idx) => ({
          caption: att.caption || '',
          sort_order: idx,
          s3_key: att.s3_key || '',
          s3_bucket: att.s3_bucket || '',
          file_name: att.file_name || att.name || '',
          file_size: att.file_size || att.size || 0,
          mime_type: att.mime_type || att.type || '',
          media_url: att.media_url || att.url || '',
          thumbnail_url: att.thumbnail_url || '',
          metadata: att.metadata || {}
        }))

        return createMessageWithAttachments({
          p_community_id: community.id,
          p_user_id: userDetails.id,
          p_content: messageToForward.content || '',
          p_message_type: messageToForward.type || (attachmentsPayload.length ? 'file' : 'text'),
          p_reply_to_id: null,
          p_attachments: attachmentsPayload,
          p_is_forwarded: true
        })
      })

      await Promise.all(forwardPromises)

      const forwardedToActive = communities.some((c) => String(c.id) === String(activeCommunity?.id))

      if (forwardedToActive) {
        const tempIdBase = `forward-temp-${Date.now()}`

        communities
          .filter((c) => String(c.id) === String(activeCommunity?.id))
          .forEach((c, i) => {
            const tempId = `${tempIdBase}-${i}-${Math.random().toString(36).slice(2, 6)}`

            const forwardedMessage = {
              id: tempId,
              community_id: activeCommunity.id,
              userid: userDetails.id,
              content: messageToForward.content || '',
              type: messageToForward.type || ((messageToForward.attachments || []).length ? 'file' : 'text'),
              attachments: (messageToForward.attachments || []).map((att) => ({ ...att })),
              user_info: {
                userid: userDetails.id,
                first_name: userDetails.first_name || '',
                last_name: userDetails.last_name || '',
                users_flag_url: userDetails.users_flag_url || ''
              },
              is_forwarded: true,
              timestamp: new Date().toISOString(),
              pending: false,
              reply_to_id: null,
              repliedMessage: null
            }

            setChats((prev) => [...prev, forwardedMessage])
          })

        setTimeout(() => {
          scrollToBottom()
        }, 0)
      }

      setForwardModalVisible(false)
      setMessageToForward(null)
      setSelectedCommunitiesForForward([])
    } catch (err) {
      console.error('Forward failed', err)
    } finally {
      setIsForwarding(false)
    }
  }

  const scrollToBottom = (forceInstant = false) => {
    if (!containerRef.current) return

    const container = containerRef.current

    const scrollNow = (useSmooth = false) => {
      if (!container) return

      const scrollHeight = container.scrollHeight
      const clientHeight = container.clientHeight
      const maxScrollTop = scrollHeight - clientHeight

      container.scrollTo({
        top: maxScrollTop,
        behavior: forceInstant || !useSmooth ? 'auto' : 'smooth'
      })
    }

    // For instant scroll (like when adding optimistic message), skip media waiting
    if (forceInstant) {
      requestAnimationFrame(() => {
        scrollNow(false)
      })

      return
    }

    // Wait for images/videos to load before scrolling (for smooth scroll)
    const waitForMedia = () => {
      const images = container.querySelectorAll('img:not([src=""])')
      const videos = container.querySelectorAll('video:not([src=""])')
      const mediaElements = [...Array.from(images), ...Array.from(videos)]

      if (mediaElements.length === 0) {
        // No media, scroll immediately with smooth behavior
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollNow(true)
          })
        })

        return
      }

      let loadedCount = 0
      let hasPendingLoads = false
      const totalMedia = mediaElements.length

      const checkComplete = () => {
        loadedCount += 1
        if (loadedCount === totalMedia) {
          // All media loaded, scroll smoothly after rendering
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              scrollNow(true)
            })
          })
        }
      }

      // Check which images are already loaded
      mediaElements.forEach((media) => {
        if (media.complete || (media.tagName === 'VIDEO' && media.readyState >= 2)) {
          // Already loaded
          checkComplete()
        } else {
          hasPendingLoads = true
          // Wait for load
          const onLoad = () => checkComplete()
          const onError = () => checkComplete()

          media.addEventListener('load', onLoad, { once: true })
          media.addEventListener('error', onError, { once: true })
          if (media.tagName === 'VIDEO') {
            media.addEventListener('loadeddata', onLoad, { once: true })
          }
        }
      })

      // If all were already loaded (no pending loads)
      if (!hasPendingLoads && loadedCount === totalMedia) {
        checkComplete()
      }

      // Fallback: scroll after max 800ms even if images haven't loaded (reduced from 1500ms)
      setTimeout(() => {
        scrollNow(true)
      }, 800)
    }

    // Use requestAnimationFrame to ensure DOM has updated
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        waitForMedia()
      })
    })
  }

  const scrollToMessage = (messageId) => {
    if (!containerRef.current || !messageId) return

    const messageElement = document.getElementById(`msg-${removeMediaIndex(messageId)}`)

    if (messageElement) {
      // Scroll to the message
      messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' })

      // Highlight the message temporarily
      messageElement.classList.add('highlight-message')
      setTimeout(() => {
        messageElement.classList.remove('highlight-message')
      }, 2000)
    } else {
      // If message is not in DOM (might be in older messages), try to load it
      console.log('Message not found in current view, might need to load older messages')
    }
  }

  const postChatMessage = async (chatMessageBody, tempId, attachments = [], hasUrl = false, urlPreviewMetadata = null) => {
    try {
      const { repliedMessage, id, pending, ...bodyToSend } = chatMessageBody

      // Map attachments to include captions from UI state
      const attachmentsWithCaptions = attachments.map((att, index) => {
        // Use the attachment at the same index from UI state to get the correct caption
        const uiAttachment = attachments[index]

        return {
          ...att,
          caption: uiAttachment?.caption || '',
          sort_order: index
        }
      })

      // Create message with attachments and reply_to_id
      const { data, error } = await createMessageWithAttachments({
        p_community_id: activeCommunity?.id,
        p_user_id: userDetails?.id,
        p_content: bodyToSend.content || '',
        p_message_type: bodyToSend.type,
        p_reply_to_id: bodyToSend.reply_to_id || null, // Make sure to include this
        p_attachments: attachmentsWithCaptions,
        p_is_forwarded: false
      })

      if (error) throw error

      // Fetch the newly created message using the RPC to get real ID and structure
      const { data: newMessage } = await getCommunityMessagesWithAttachments({
        p_community_id: activeCommunity?.id,
        p_user_id: userDetails?.id,
        p_limit: 1,
        p_offset: 0
      })

      if (newMessage?.messages?.[0]) {
        const latestMessage = newMessage.messages[0]

        // If message has URL, update it with has_url flag and set approval status
        if (hasUrl && latestMessage.id) {
          await supabase
            .from('messages')
            .update({
              has_url: true,
              approved_status: 'PENDING'
            })
            .eq('id', latestMessage.id)

          // Update the latestMessage object with the new values
          latestMessage.has_url = true
          latestMessage.approved_status = 'PENDING'
        }

        // ========== APPLY SAME REPLY LOGIC AS fetchOlderChats ==========
        let processedRepliedMessage = null

        // Pre-fetch reply user if we have an ID (even when deleted)
        let replyUser = null

        if (latestMessage.reply_user_id) {
          const { data: userInfo } = await fetchOlderMessages(latestMessage.reply_user_id)

          replyUser = userInfo || null
        }

        // if (latestMessage.reply_to_id && (latestMessage.reply_content || latestMessage.is_reply_deleted)) {
        if (latestMessage.reply_to_id) {
          if (latestMessage.is_reply_deleted) {
            // Reply is deleted - show "Message deleted" but keep user name
            processedRepliedMessage = {
              id: latestMessage.reply_to_id,
              content: null, // This will trigger "Message deleted" in UI
              userid: latestMessage.reply_user_id,
              attachmentsType: repliedMessage?.attachments[0]?.attachment_type || repliedMessage?.attachments[0]?.media_type,
              attachmentsCount: repliedMessage?.attachments?.length,
              user: replyUser || userMethods.createDefaultUser(latestMessage.reply_user_id)
            }
          } else {
            // Reply exists
            processedRepliedMessage = {
              id: latestMessage.reply_to_id,
              content: latestMessage.reply_content,
              userid: latestMessage.reply_user_id,
              attachmentsType: repliedMessage?.attachments[0]?.attachment_type || repliedMessage?.attachments[0]?.media_type,
              attachmentsCount: repliedMessage?.attachments?.length,

              user: replyUser || userMethods.createDefaultUser(latestMessage.reply_user_id)
            }
          }
        }

        // Preload images before updating to prevent blank screen
        const preloadPromises = (latestMessage.attachments || [])
          .filter((att) => att.media_url && attachmentMethods.isMediaAttachment(att.mime_type))
          .map(
            (att) =>
              new Promise((resolve) => {
                if (attachmentMethods.isImageAttachment(att.mime_type)) {
                  const img = new Image()

                  img.onload = () => resolve()
                  img.onerror = () => resolve() // Resolve even on error to not block
                  img.src = att.media_url
                } else if (attachmentMethods.isVideoAttachment(att.mime_type)) {
                  const video = document.createElement('video')

                  video.onloadeddata = () => resolve()
                  video.onerror = () => resolve()
                  video.src = att.media_url
                } else {
                  resolve()
                }
              })
          )

        // Wait for images to preload (with timeout)
        await Promise.race([
          Promise.all(preloadPromises),
          new Promise((resolve) => {
            setTimeout(() => {
              resolve()
            }, 500) // Max 500ms wait
          })
        ])

        // Build the complete message with proper reply structure
        const completeMessage = {
          ...latestMessage,
          repliedMessage: processedRepliedMessage,
          pending: false,
          // Ensure attachments don't have pending flag
          attachments: (latestMessage.attachments || []).map((att) => ({
            ...att,
            pending: false
          })),
          // Include URL preview metadata if available
          url_preview: urlPreviewMetadata || chatMessageBody.url_preview || null,
          url_preview_url: chatMessageBody.url_preview_url || null
        }

        // Replace pending message with the real one (images are now preloaded)
        setChats((prev) => prev.map((msg) => (msg.id === tempId ? completeMessage : msg)))

        moveCommunityToTop(activeCommunity?.id)

        // Smooth scroll after images are loaded and rendered
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (containerRef.current) {
              containerRef.current.scrollTo({
                top: containerRef.current.scrollHeight,
                behavior: 'smooth'
              })
            }
          })
        })
      }
    } catch (error) {
      // Remove the pending message on error
      setChats((prev) => prev.filter((msg) => msg.id !== tempId))
      console.log('Error creating message:', error)
      throw error // Re-throw to handle in sendMessage
    }
  }

  // const checkIfUserIsAdmin = async () => {
  //   try {
  //     const { data } = await supabase.from('users').select('can_act_as_bot').eq('userid', userDetails?.id).single()

  //     const isAdmin = !!data?.can_act_as_bot

  //     setIsAdminUser(isAdmin)

  //     return isAdmin
  //   } catch (error) {
  //     console.log('Error checking admin status:', error)
  //     setIsAdminUser(false)

  //     return false
  //   }
  // }

  const handleCopyClick = () => {
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 3000)
  }

  const handleCommunitySearch = (value) => {
    setSearchCommunityTerm(value)

    if (!value.trim()) {
      setFilteredGroupList(groupList)
    } else {
      const filteredList = groupList.filter((group) => group.name.toLowerCase().includes(value.toLowerCase()))

      setFilteredGroupList(filteredList)
    }
  }

  const handleChange = (newValue) => {
    // const formattedValue = newValue.charAt(0).toUpperCase() + newValue.slice(1)

    setValue(newValue)

    if (inputRef.current) {
      textMethods.autoResizeTextarea(inputRef.current)
    }

    // Handle mention detection for internal communities
    if (activeCommunity?.is_internal && internalCommunityMembers.length > 0) {
      const cursorPosition = inputRef.current?.selectionStart || newValue.length
      const textBeforeCursor = newValue.substring(0, cursorPosition)
      const lastAtIndex = textBeforeCursor.lastIndexOf('@')

      if (lastAtIndex !== -1) {
        const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1)
        const charAfterAt = newValue.charAt(lastAtIndex + 1)
        const hasMultipleAt = charAfterAt === '@' || textAfterAt.startsWith('@')

        const hasInvalidChar = REG_EX.MENTION_INVALID_CHAR.test(textAfterAt) || hasMultipleAt

        if (!hasInvalidChar) {
          const searchTerm = textAfterAt.trim().toLowerCase()

          setMentionSearchTerm(searchTerm)
          setMentionStartPosition(lastAtIndex)
          setShowMentionDropdown(true)
          setSelectedMentionIndex(0)
        } else {
          setShowMentionDropdown(false)
          setMentionSearchTerm('')
          setMentionStartPosition(null)
        }
      } else {
        setShowMentionDropdown(false)
        setMentionSearchTerm('')
        setMentionStartPosition(null)
      }
    } else {
      setShowMentionDropdown(false)
      setMentionSearchTerm('')
      setMentionStartPosition(null)
    }
  }

  const renderTextMessage = () => {
    if (activeCommunity?.admin_only_message && userRoleInCommunity !== 'ADMIN') {
      return <p>{t('ADMIN_ONLY_MESSAGE')}</p>
    }

    return <p>{t('ADMIN_ONLY_MESSAGE')}</p>
  }

  const renderMainContent = () => {
    if (activeCommunity?.isUrlApproval) {
      return (
        <div className="url-approval-panel">
          <div className="url-approval-header">
            <h3 className="url-approval-title">URL Approval Queue</h3>
            <p className="url-approval-subtitle">Review and approve or reject URLs shared in communities.</p>
          </div>

          <div className="url-approval-content">
            {pendingUrlsError && <div className="url-approval-error">{pendingUrlsError}</div>}

            {!pendingUrlsError && pendingUrlMessages.length === 0 && (
              <div className="url-approval-empty">
                <p>No URLs require your approval right now.</p>
              </div>
            )}

            {pendingUrlMessages.length > 0 && (
              <div className="url-approval-list">
                {pendingUrlMessages.map((msg) => {
                  const isPending = msg.approved_status === 'PENDING'
                  const isApproved = msg.approved_status === 'APPROVED'
                  const isRejected = msg.approved_status === 'REJECTED'

                  // Derive latest admin name from approving / declining admins
                  let adminName = ''
                  const approvingAdmins = Array.isArray(msg.approving_admins) ? msg.approving_admins : []
                  const decliningAdmins = Array.isArray(msg.declining_admins) ? msg.declining_admins : []

                  if (isApproved && approvingAdmins.length) {
                    const last = approvingAdmins[approvingAdmins.length - 1]

                    adminName = `${last.first_name || ''} ${last.last_name || ''}`.trim()
                  } else if (isRejected && (decliningAdmins.length || approvingAdmins.length)) {
                    const source = decliningAdmins.length ? decliningAdmins : approvingAdmins
                    const last = source[source.length - 1]

                    adminName = `${last.first_name || ''} ${last.last_name || ''}`.trim()
                  }

                  let statusClass = ''

                  if (isPending) statusClass = 'pending'
                  else if (isApproved) statusClass = 'approved'
                  else if (isRejected) statusClass = 'rejected'

                  // Extract all URLs from message content and attachment captions
                  const allUrls = []

                  if (msg.content) {
                    allUrls.push(...urlMethods.extractUrls(msg.content))
                  }
                  if (msg.caption) {
                    allUrls.push(...urlMethods.extractUrls(msg.caption))
                  }
                  if (Array.isArray(msg.attachments)) {
                    msg.attachments.forEach((att) => {
                      if (att.caption) {
                        allUrls.push(...urlMethods.extractUrls(att.caption))
                      }
                    })
                  }
                  // Remove duplicates
                  const uniqueUrls = [...new Set(allUrls)]

                  return (
                    <div key={msg.id} className="url-card">
                      <div className="url-card-header">
                        <div className="url-card-user">
                          <div className="url-card-user-name">
                            {msg.user_first_name} {msg.user_last_name}
                          </div>
                          <div className="url-card-community">{msg?.community_name}</div>
                          <div className="url-card-date">
                            <div className="date">
                              <b>{t('CREATED_AT')} : </b>
                              {formatDate(msg?.created_at)}
                            </div>
                            <div className="time">{formatTime(msg?.created_at)}</div>
                          </div>
                        </div>
                        <div className={`url-card-status ${statusClass}`}>
                          {isPending && 'Pending'}
                          {isApproved && 'Approved'}
                          {isRejected && 'Rejected'}
                        </div>
                      </div>

                      <div className="url-card-body">
                        {uniqueUrls.length > 0 ? (
                          <ul className="url-list" style={{ listStyle: 'disc', paddingLeft: '20px', margin: 0 }}>
                            {uniqueUrls.map((url, index) => (
                              <li key={index} style={{ marginBottom: '8px', wordBreak: 'break-all' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                  <a href={url} target="_blank" rel="noreferrer" style={{ flex: 1 }}>
                                    {url}
                                  </a>
                                  {copiedUrlId === `${msg.id}-${index}` ? (
                                    <span style={{ color: '#4caf50', fontSize: '14px', fontWeight: 500 }}>Copied</span>
                                  ) : (
                                    <i
                                      className="pi pi-copy url-copy-icon"
                                      onClick={async () => {
                                        try {
                                          await navigator.clipboard?.writeText(url)
                                          setCopiedUrlId(`${msg.id}-${index}`)
                                          setTimeout(() => {
                                            setCopiedUrlId(null)
                                          }, 2000)
                                        } catch (err) {
                                          console.error('Failed to copy URL:', err)
                                        }
                                      }}
                                      title="Copy URL"
                                      style={{ cursor: 'pointer', flexShrink: 0 }}
                                    />
                                  )}
                                </div>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <div className="url-card-url" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <span style={{ color: '#999' }}>No URLs found</span>
                          </div>
                        )}
                        {msg.caption && <div className="url-card-caption">{msg.caption}</div>}
                      </div>

                      <div className="url-card-footer">
                        {isPending ? (
                          <div className="url-card-actions">
                            <Button label="Reject" className="p-button url-card-btn url-card-btn-reject" disabled={isUrlActionLoading} onClick={() => handleUrlApprovalAction(msg, 'reject')} />
                            <Button label="Approve" className="p-button url-card-btn url-card-btn-approve" disabled={isUrlActionLoading} onClick={() => handleUrlApprovalAction(msg, 'approve')} />
                          </div>
                        ) : (
                          adminName && (
                            <div className="url-card-admin-info">
                              {isApproved && (
                                <div className="admin-approved-info">
                                  <span>
                                    <b> {t('APPROVED_BY')} : </b>
                                    {adminName},
                                  </span>
                                  {msg?.updated_at && (
                                    <div className="approved-date">
                                      <div className="date">
                                        <b>{t('APPROVED_ON')} : </b>
                                        {formatDate(msg?.updated_at)}
                                      </div>
                                      <div className="time">{formatTime(msg?.updated_at)}</div>
                                    </div>
                                  )}
                                </div>
                              )}
                              {isRejected && (
                                <div className="admin-approved-info">
                                  <span>
                                    <b>Rejected by</b> :{adminName} ,
                                  </span>
                                  {msg?.updated_at && (
                                    <div className="approved-date">
                                      <div className="date">
                                        <b>{t('REJECTED_AT')} :</b>
                                        {formatDate(msg?.updated_at)}
                                      </div>
                                      <div className="time">{formatTime(msg?.updated_at)}</div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        </div>
      )
    }

    if (activeCommunity?.isYourNews) {
      return (
        <div className="your-news-panel">
          <YourNewsContent reminderTitle={activeCommunity?.name} selectedReminder={reminders} historyEntries={selectedHistoryEntries} emptyMessage="Currently no news is available for this tab." showGuidelines={false} isLoading={dataLoading} dateHeaderClassName="community-date-header" showScrollTopButton={false} />
        </div>
      )
    }

    if (attachments.length > 0 && !isUploadingImage) {
      return <AttachmentPreview attachments={attachments} scrollToBottom={scrollToBottom} removeAttachment={removeAttachment} setAttachments={setAttachments} addFiles={addFiles} handleMediaSelected={handleMediaSelected} handleDocumentSelected={handleDocumentSelected} onSendAttachments={sendMessage} onUpdateAttachment={onUpdateCaption} isUploadingImage={isUploadingImage} isInternalCommunity={activeCommunity?.is_internal} mentionMembers={internalCommunityMembers} />
    }

    return (
      <>
        <div className="chat-messages" ref={containerRef}>
          <div className={`top-loader ${isFetchingOlder && !activeCommunity?.isCreateOwn ? 'show' : ''}`} aria-live="polite" aria-busy={isFetchingOlder && !activeCommunity?.isCreateOwn}>
            <i className="pi pi-spinner pi-spin" />
            <span>Loading messages…</span>
          </div>

          {activeCommunity?.isCreateOwn ? (
            <div className="create-community-card">
              <div className="create-community-card__title">Create Your Own Community</div>
              <div className="create-community-card__instructions">
                {instructionsForCreateCommunity.length ? (
                  instructionsForCreateCommunity.map((item, idx) => (
                    <div key={`${item?.title || 'instruction'}-${idx}`} className="create-community-card__item">
                      <div className="create-community-card__item-title">{item?.title || 'Instruction'}</div>
                      <div className="create-community-card__item-description">
                        {item?.description?.split('\n').map((line, index) => (
                          <div key={index} className="description-line">
                            {line?.includes('@') ? <strong>{line.trim()}</strong> : line}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="create-community-card__item-description">No instructions available.</div>
                )}
              </div>
            </div>
          ) : (
            groupedMessages.map(([date, msgs]) => (
              <div key={date} className="date-group">
                <div className="date-separator">{!isFetchingOlder && <span className="date-label">{date}</span>}</div>
                {msgs
                  .filter((msg) => {
                    // Filter messages based on approval status
                    // If message has URL and is pending, only show to sender
                    if (msg?.has_url && msg?.approved_status === 'PENDING') {
                      return msg?.userid === userDetails?.id
                    }
                    // Show all other messages

                    return true
                  })
                  .flatMap((msg) => {
                    const isOutgoing = msg?.userid === userDetails?.id
                    const isPendingApproval = msg?.has_url && msg?.approved_status === 'PENDING'

                    const ALLOWED_DURATION = 5 * 60 * 1000 // 5 minutes in milliseconds
                    const messageTimestamp = msg?.timestamp ? new Date(msg.timestamp).getTime() : null
                    const isActionAllowed = isOutgoing

                    // Check if we need to split attachments into separate bubbles
                    // Split when: 1) PDFs/docs mixed with images/media, or 2) Any attachment has a caption
                    const hasDocuments = (msg.attachments || []).some((att) => !attachmentMethods.isMediaAttachment(att.mime_type))
                    const hasMedia = (msg.attachments || []).some((att) => attachmentMethods.isMediaAttachment(att.mime_type))
                    const hasCaption = (msg.attachments || []).some((att) => att.caption && att.caption.trim())
                    const shouldSplitAttachments = (msg.attachments || []).length > 0 && (hasCaption || (hasDocuments && hasMedia))

                    // If we need to split, create separate message objects for each attachment in original order
                    if (shouldSplitAttachments) {
                      const hasTextContent = Boolean(msg?.content?.trim())
                      const messagesToRender = []

                      // First bubble: text content only (if exists)
                      if (hasTextContent) {
                        messagesToRender.push({
                          ...msg,
                          attachments: [],
                          content: msg.content,
                          splitFromMultiMedia: true
                        })
                      }

                      // Create separate bubbles for each attachment in original order
                      ;(msg.attachments || []).forEach((attachment, attachmentIndex) => {
                        messagesToRender.push({
                          ...msg,
                          id: `${msg.id}-media-${attachmentIndex}`,
                          attachments: [attachment],
                          content: '', // Clear text content for attachment-only bubbles
                          splitFromMultiMedia: true,
                          originalAttachmentIndex: attachmentIndex // Track the original attachment index
                        })
                      })

                      return messagesToRender.map((splitMsg, splitIndex) => {
                        // For split messages with attachments, use originalAttachmentIndex
                        // For text-only bubbles (no attachments), use -1 or 0 (won't be used for edit)
                        const attachmentIndexForEdit = splitMsg.originalAttachmentIndex ?? null
                        const splitMessageTimestamp = splitMsg?.timestamp ? new Date(splitMsg.timestamp).getTime() : null

                        const menuProps = getMessageMenuProps(msg, isOutgoing, attachmentIndexForEdit, splitMessageTimestamp)
                        const incomingMenuNode = !isOutgoing ? <MessageMenu {...menuProps} /> : null

                        return (
                          <div key={splitMsg.id} className={`msg ${isOutgoing ? 'out' : 'in'}`} id={`msg-${splitMsg.id.split('-media-')[0]}`}>
                            <ChatMessage msg={splitMsg} isOutgoing={isOutgoing} onChatPersonally={() => handleChatPersonally(msg)} formatTime={formatTime} setRepliedMessage={setRepliedMessage} onAttachmentClick={openViewer} menuNode={incomingMenuNode} onReplyClick={scrollToMessage} activeCommunity={activeCommunity} userRoleInCommunity={userRoleInCommunity} internalCommunityMembers={internalCommunityMembers} />
                            {isOutgoing && (
                              <div className={`message-options ${splitMsg.pending ? 'invisible' : 'visible'}`}>
                                <MessageMenu {...menuProps} />
                              </div>
                            )}
                          </div>
                        )
                      })
                    }

                    // Normal rendering for messages that don't need splitting
                    const menuProps = getMessageMenuProps(msg, isOutgoing, null, messageTimestamp)
                    const incomingMenuNode = !isOutgoing ? <MessageMenu {...menuProps} /> : null

                    return (
                      <div key={msg.id} className={`msg ${isOutgoing ? 'out' : 'in'}`} id={`msg-${msg.id}`}>
                        <ChatMessage msg={msg} isOutgoing={isOutgoing} formatTime={formatTime} onChatPersonally={() => handleChatPersonally(msg)} setRepliedMessage={setRepliedMessage} onAttachmentClick={openViewer} menuNode={incomingMenuNode} onReplyClick={scrollToMessage} activeCommunity={activeCommunity} userRoleInCommunity={userRoleInCommunity} internalCommunityMembers={internalCommunityMembers} />
                        {isOutgoing && (
                          <div className={`message-options ${msg.pending ? 'invisible' : 'visible'}`}>
                            <MessageMenu {...menuProps} />
                          </div>
                        )}
                      </div>
                    )
                  })}
              </div>
            ))
          )}
        </div>

        <div className={`chat-input ${isCoffeePost ? 'coffee-post-screen-chat-input' : ''}`}>
          <ScrollPageToBottom />

          {!showRedirectText ? (
            <>
              {/* Check if community is admin-only and user is not admin */}
              {activeCommunity?.admin_only_message && userRoleInCommunity !== 'ADMIN' ? (
                <div className="redirect-login-text">{renderTextMessage()}</div>
              ) : (
                <div className={`input-wrapper ${activeCommunity?.isCreateOwn ? 'disabled-wrapper' : ''} ${isCoffeePost ? 'coffee-post-input-wrapper' : ''}`}>
                  {repliedMessage && (
                    <div className="reply-preview">
                      <div className="reply-header-container">
                        <div className="reply-header">
                          <p className="replying-to">{repliedMessage?.userid === userDetails?.id ? 'Replying to you' : `Replying to ${repliedMessage?.user_info?.first_name || repliedMessage?.user?.first_name || 'User'}`}</p>
                        </div>
                        <div className="reply-attachment-container">
                          {repliedMessage?.attachments?.length > 0 && (
                            <div className="reply-body with-attachment">
                              <div className="attachment-info">
                                <div className="photo-info">
                                  {((repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.attachment_type === 'image' || repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.media_type === 'image') && <i className="pi pi-camera"></i>) || null}
                                  {((repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.attachment_type === 'video' || repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.media_type === 'video') && <i className="pi pi-video"></i>) || null}
                                  {((repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.attachment_type === 'document' || repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.media_type === 'document') && <i className="pi pi-file-pdf"></i>) || null}

                                  <span>
                                    {((repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.attachment_type === 'image' || repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.media_type === 'image') && 'Photo') || null}
                                    {((repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.attachment_type === 'video' || repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.media_type === 'video') && 'Video') || null}
                                    {((repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.attachment_type === 'document' || repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.media_type === 'document') && 'Document') || null}
                                    {repliedMessage?.replyAttachmentIndex == null && !((repliedMessage?.content && repliedMessage.content.trim()) || (repliedMessage?.attachments?.[0]?.caption && repliedMessage.attachments?.[0]?.caption.trim())) && repliedMessage?.attachments?.length > 1 ? ` (+${repliedMessage.attachments.length - 1})` : ''}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <p className="reply-caption">{repliedMessage?.content || repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.caption}</p>
                      </div>
                      <div className="reply-attachment-image-container">
                        <div>{(repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.attachment_type === 'image' || repliedMessage?.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.media_type === 'image') && <img src={repliedMessage.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.attachment_url || repliedMessage.attachments?.[repliedMessage?.replyAttachmentIndex ?? 0]?.media_url} className="reply-attachment-thumbnail" alt="attachment thumbnail" />}</div>
                        <button className="cancel-reply-btn" onClick={() => setRepliedMessage(null)}>
                          ✕
                        </button>
                      </div>
                    </div>
                  )}

                  {/* URL Preview in Input Area */}
                  {inputPreviewUrl && (
                    <URLPreview
                      metadata={inputPreviewMetadata}
                      isLoading={isInputMetadataLoading && !inputPreviewMetadata}
                      onClose={() => {
                        setInputPreviewUrl(null)
                        setInputPreviewMetadata(null)
                      }}
                      showCloseButton={true}
                      className="input-url-preview"
                      isInInputArea={true}
                    />
                  )}

                  <div className="input-area">
                    <AttachmentMenu setShowRedirectText={!userDetails?.id ? setShowRedirectText : false} ref={uploaderRef} onMediaSelected={handleMediaSelected} onDocumentSelected={handleDocumentSelected} isCoffeePost={isCoffeePost} />

                    <div className="input-area-container">
                      <div>
                        <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png" alt="coffee-web-logo" className="input-logo" />
                      </div>
                      <div style={{ position: 'relative', width: '100%' }}>
                        <InputTextarea ref={inputRef} rows={isWebView ? 1 : 2} cols={1} value={value} onKeyDown={(e) => handleKeyDown(e)} onPaste={(e) => handlePaste(e)} onChange={(e) => handleChange(e.target.value)} placeholder={`${placeholderText()}...`} className={`input-field ${isCoffeePost ? 'coffee-post-input' : ''}`} />
                        {showMentionDropdown &&
                          activeCommunity?.is_internal &&
                          internalCommunityMembers.length > 0 &&
                          (() => {
                            const { members: filteredMembers } = getFilteredMentionMembers()

                            if (filteredMembers.length === 0) return null

                            return <MentionDropdown members={filteredMembers} selectedIndex={selectedMentionIndex} onSelect={insertMention} onHover={setSelectedMentionIndex} />
                          })()}
                      </div>
                    </div>
                    <Button rounded icon="pi pi-send send-icon" className={`send-button  ${value?.length > 0 ? 'active-on-input-typing' : ''} `} onClick={sendMessage} />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="redirect-login-text">
              Please <span onClick={handleLogin}>{t('LOGIN_AND_CREATE_ACCOUNT')}</span> to Join the Conversation
            </div>
          )}
        </div>
      </>
    )
  }

  // ---------- URL APPROVAL HELPERS ----------

  const fetchPendingUrlMessages = React.useCallback(async () => {
    if (!userDetails?.id) return

    setPendingUrlsError(null)

    try {
      const { data, error } = await getPendingUrlMessages({
        p_admin_user_id: userDetails?.id
      })

      if (error) {
        throw error
      }

      // RPC can return either a plain array of rows or an object wrapper.
      let list = []

      if (Array.isArray(data)) {
        list = data
      } else if (data && Array.isArray(data.messages)) {
        list = data.messages
      } else if (data && Array.isArray(data.pending_messages)) {
        list = data.pending_messages
      }

      setPendingUrlMessages(list)
    } catch (err) {
      console.error('Error fetching pending URL messages:', err)
      setPendingUrlsError('Unable to load pending URLs. Please try again.')
    }
  }, [userDetails?.id])

  const handleUrlApprovalAction = async (message, action) => {
    if (!message?.id || !userDetails?.id) return
    if (isUrlActionLoading) return

    setIsUrlActionLoading(true)

    try {
      if (action === 'approve') {
        const { error } = await approveMessageUrl({
          p_message_id: message.id,
          p_admin_user_id: userDetails?.id
        })

        if (error) throw error
      } else if (action === 'reject') {
        const { error } = await rejectMessageUrl({
          p_message_id: message.id,
          p_admin_user_id: userDetails?.id
        })

        if (error) throw error
      }

      // Real-time handler will automatically refresh the list when status changes
    } catch (err) {
      console.error(`Error performing URL ${action}:`, err)
    } finally {
      setIsUrlActionLoading(false)
    }
  }

  useEffect(() => {
    if (!activeCommunity?.isUrlApproval || !isAdminUser || !userDetails?.id) return

    fetchPendingUrlMessages()
  }, [activeCommunity?.id, activeCommunity?.isUrlApproval, isAdminUser, userDetails?.id, fetchPendingUrlMessages])

  // Real-time subscription for URL approval panel
  useEffect(() => {
    if (!activeCommunity?.isUrlApproval || !isAdminUser || !userDetails?.id) return

    return subscribeToRealTimeApprovalUrlLinks(fetchPendingUrlMessages)
  }, [activeCommunity?.isUrlApproval, isAdminUser, userDetails?.id, fetchPendingUrlMessages])

  let modalTitle = 'Confirm'

  if (modalAction === 'edit') {
    modalTitle = 'Edit Message'
  } else if (modalAction === 'deleteForMe') {
    modalTitle = 'Delete Message For Me'
  } else if (modalAction === 'deleteForEveryone') {
    modalTitle = 'Delete Message For Everyone'
  } else if (modalAction === 'deleteMessageByAdmin') {
    modalTitle = "Delete User's Message" // eslint-disable-line quotes
  } else if (modalAction === 'deleteAllMessageByAdmin') {
    modalTitle = "Delete User's All Message" // eslint-disable-line quotes
  } else if (modalAction === 'blockUserByAdmin') {
    modalTitle = 'Block User'
  } else if (modalAction === 'reportAbuse') {
    modalTitle = 'Report Abuse'
  }

  const shareListModalContent = () => (
    <div className="share-news-feed" data-testid="share-news-feed-main-container">
      {activeSocialMediaLists.includes('Copy') && (
        <div className="share-news-feed-container" data-testid="copy-container">
          <div className="icon-container copy-button" onClick={handleCopyClick} data-testid="copy-icon-container">
            <i className="pi pi-copy copy-icon" quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} value={shortenUrl} data-testid="tool-tip" />
          </div>
          <p className="icons-text" onClick={handleCopyClick}>
            {t('COPY')}
          </p>
          <Tooltip target=".copy-button" position="bottom" content={'Coming Soon'} className="copy-tooltip" />
        </div>
      )}

      {/* Commented for WhatsApp as per discussion */}
      {/* {activeSocialMediaLists.includes('WhatsApp') && (
        <div className="share-news-feed-container" data-testid="whats-app-container">
          <WhatsappShareButton url={shareLinksFowWhatsApp} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitleForWhatsApp} media={imgUrl}>
            <div className="icon-container" data-testid="whatsapp-icon-container">
              <i className="pi pi-whatsapp whatsapp-icon" />
            </div>
            <p className="icons-text">{t('WHATS_APP')}</p>
          </WhatsappShareButton>
          <Tooltip target=".whatsapp-icon" position="bottom" content={'Coming Soon'} className="copy-tooltip" />
        </div>
      )} */}

      {activeSocialMediaLists.includes('WhatsApp') && (
        <div className="share-news-feed-container" data-testid="whats-app-container">
          <div className="icon-container" data-testid="whatsapp-icon-container" style={{ cursor: 'pointer', pointerEvents: 'auto' }}>
            <i className="pi pi-whatsapp whatsapp-icon" />
          </div>
          <p className="icons-text">{t('WHATS_APP')}</p>
          <Tooltip target=".whatsapp-icon" position="bottom" content="Coming Soon" className="copy-tooltip" />
        </div>
      )}

      {activeSocialMediaLists.includes('Facebook') && (
        <div className="social-media-div">
          <FacebookShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <FacebookIcon size={40} round={true} />
            <p className="icons-text">{t('FACEBOOK')}</p>
          </FacebookShareButton>
        </div>
      )}
      {activeSocialMediaLists.includes('LinkedIn') && (
        <div className="social-media-div">
          <LinkedinShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <LinkedinIcon size={40} round={true} />
            <p className="icons-text">{t('LINKED_IN')}</p>
          </LinkedinShareButton>
        </div>
      )}
      {activeSocialMediaLists.includes('Twitter') && (
        <div className="social-media-div">
          <TwitterShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <TwitterIcon size={40} round={true} />
            <p className="icons-text">{t('TWITTER')}</p>
          </TwitterShareButton>
        </div>
      )}
      {activeSocialMediaLists.includes('Telegram') && (
        <div className="social-media-div">
          <TelegramShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <TelegramIcon size={40} round={true} />
            <p className="icons-text">{t('TELEGRAM')}</p>
          </TelegramShareButton>
        </div>
      )}
      {activeSocialMediaLists.includes('Email') && (
        <div className="social-media-div">
          <EmailShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <EmailIcon size={40} round={true} />
            <p className="icons-text">{t('MAIL')}</p>
          </EmailShareButton>
        </div>
      )}
    </div>
  )

  const getSubscriptionLabelColor = (ele) => {
    const colorCodes = ele?.subscription_colors || []

    return `linear-gradient(100deg, ${colorCodes[0]}, ${colorCodes[1]}, ${colorCodes[2]})`
  }

  const ScrollPageToBottom = () => (
    <div className="scroll-to-bottom-container">
      {showScrollButton && (
        <div className="scroll-to-bottom-icon">
          <i className="pi pi-angle-double-down scroll-button" onClick={scrollToBottom} />
          {unreadCount > 0 && <span className="unread-count-badge">{unreadCount}</span>}
        </div>
      )}
    </div>
  )

  const CommunitySubscriptionTypes = ({ subTypes, isCoffeePost }) =>
    isCommunitiesLoading ? (
      <div className="subscription-skeleton">
        <Skeleton className="custom-skelton" width="10rem" height="2rem"></Skeleton>
      </div>
    ) : (
      <div className={`published_for_div ${isCoffeePost ? 'coffee-post-subscription-types' : ''}`}>
        <div className="published_for_sub_div" data-testid="subscription-code">
          {subTypes?.map((ele, index) => (
            <React.Fragment key={index}>
              {ele?.subscription_code && (
                <span
                  className="eachLabeling"
                  style={{
                    backgroundSize: '400% 400%',
                    backgroundImage: getSubscriptionLabelColor(ele),
                    animation: 'gradient 7s ease infinite',
                    color: 'white',
                    borderRadius: '4px',
                    fontSize: '8px',
                    padding: '1px 4px',
                    margin: '1px 2px'
                  }}
                >
                  {ele?.subscription_code}
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    )

  const placeholderText = () => {
    if (!activeCommunity?.name) return 'Loading'

    // Split name into words
    const words = activeCommunity.name.split(/\s+/)

    if (words.length === 1) {
      // If single word, just append Talks
      return `${words[0]} Talks`
    }

    // Replace last word with Talks and join back
    words[words.length - 1] = 'Talks'

    return words.join(' ')
  }

  const instructionsForCreateCommunity = activeCommunity?.isCreateOwn ? activeCommunity?.instructions || createCommunityInstructions || [] : []

  // Helper functions for mention functionality
  const getFilteredMentionMembers = () => {
    const searchLower = (mentionSearchTerm || '').toLowerCase()
    const everyoneOption = { isEveryone: true, first_name: 'Everyone', last_name: '', userid: 'everyone', id: 'everyone' }
    const results = []

    // Add "Everyone" option if search term matches or is empty
    if (!searchLower || 'everyone'.includes(searchLower)) {
      results.push(everyoneOption)
    }

    // Filter members based on search term
    const filteredMembers = internalCommunityMembers.filter((member) => {
      if (!mentionSearchTerm) return true
      const firstName = (member.first_name || '').toLowerCase()
      const lastName = (member.last_name || '').toLowerCase()
      const fullName = `${firstName} ${lastName}`.trim()

      return firstName.includes(searchLower) || lastName.includes(searchLower) || fullName.includes(searchLower)
    })

    results.push(...filteredMembers)

    return { members: results, showNotFound: results.length === 0 }
  }

  const getFilteredEditMentionMembers = () => {
    const searchLower = (editMentionSearchTerm || '').toLowerCase()
    const everyoneOption = { isEveryone: true, first_name: 'Everyone', last_name: '', userid: 'everyone', id: 'everyone' }
    const results = []

    if (!searchLower || 'everyone'.includes(searchLower)) {
      results.push(everyoneOption)
    }

    const filteredMembers = internalCommunityMembers.filter((member) => {
      if (!editMentionSearchTerm) return true
      const firstName = (member.first_name || '').toLowerCase()
      const lastName = (member.last_name || '').toLowerCase()
      const fullName = `${firstName} ${lastName}`.trim()

      return firstName.includes(searchLower) || lastName.includes(searchLower) || fullName.includes(searchLower)
    })

    results.push(...filteredMembers)

    return { members: results, showNotFound: results.length === 0 }
  }

  const getInitials = (firstName) => (firstName || '').trim().charAt(0).toUpperCase() || ''

  const insertMention = (member) => {
    if (!member || mentionStartPosition === null) return

    // Handle "Everyone" special case
    if (member.isEveryone) {
      const mentionText = '@Everyone'
      const currentValue = value
      const textBeforeMention = currentValue.substring(0, mentionStartPosition)
      const textAfterAt = currentValue.substring(mentionStartPosition + 1)
      const mentionEndMatch = textAfterAt.match(REG_EX.MENTION_END_MATCH)
      const textToReplace = mentionEndMatch ? mentionEndMatch[0] : textAfterAt.split(/\s/)[0] || ''
      const textAfterMention = currentValue.substring(mentionStartPosition + 1 + textToReplace.length)
      const newValue = `${textBeforeMention}${mentionText} ${textAfterMention}`

      setValue(newValue)
      setShowMentionDropdown(false)
      setMentionSearchTerm('')
      setMentionStartPosition(null)
      setSelectedMentionIndex(0)

      setTimeout(() => {
        if (inputRef.current) {
          const newCursorPosition = textBeforeMention.length + mentionText.length + 1

          inputRef.current.focus()
          inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition)
          textMethods.autoResizeTextarea(inputRef.current)
        }
      }, 0)

      return
    }

    const firstName = member.first_name || ''
    const lastName = member.last_name || ''
    const fullName = `${firstName} ${lastName}`.trim() || 'User'
    const mentionText = `@${fullName}`

    const currentValue = value
    const textBeforeMention = currentValue.substring(0, mentionStartPosition)
    const textAfterAt = currentValue.substring(mentionStartPosition + 1)
    const mentionEndMatch = textAfterAt.match(REG_EX.MENTION_END_MATCH)
    const textToReplace = mentionEndMatch ? mentionEndMatch[0] : textAfterAt.split(/\s/)[0] || ''
    const textAfterMention = currentValue.substring(mentionStartPosition + 1 + textToReplace.length)
    const newValue = `${textBeforeMention}${mentionText} ${textAfterMention}`

    setValue(newValue)
    setShowMentionDropdown(false)
    setMentionSearchTerm('')
    setMentionStartPosition(null)
    setSelectedMentionIndex(0)

    setTimeout(() => {
      if (inputRef.current) {
        const newCursorPosition = textBeforeMention.length + mentionText.length + 1

        inputRef.current.focus()
        inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition)
        textMethods.autoResizeTextarea(inputRef.current)

        const textAfterInsertion = newValue.substring(newCursorPosition)

        if (textAfterInsertion.includes('@')) {
          handleChange(newValue)
        }
      }
    }, 0)
  }

  const insertEditMention = (member) => {
    if (!member || editMentionStartPosition === null) return

    // Handle "Everyone" special case
    if (member.isEveryone) {
      const mentionText = '@Everyone'
      const currentValue = editValue
      const textBeforeMention = currentValue.substring(0, editMentionStartPosition)
      const textAfterAt = currentValue.substring(editMentionStartPosition + 1)
      const mentionEndMatch = textAfterAt.match(REG_EX.MENTION_END_MATCH)
      const textToReplace = mentionEndMatch ? mentionEndMatch[0] : textAfterAt.split(/\s/)[0] || ''
      const textAfterMention = currentValue.substring(editMentionStartPosition + 1 + textToReplace.length)
      const newValue = `${textBeforeMention}${mentionText} ${textAfterMention}`

      setEditValue(newValue)
      setShowEditMentionDropdown(false)
      setEditMentionSearchTerm('')
      setEditMentionStartPosition(null)
      setSelectedEditMentionIndex(0)

      setTimeout(() => {
        if (editInputRef.current) {
          const newCursorPosition = textBeforeMention.length + mentionText.length + 1

          editInputRef.current.focus()
          editInputRef.current.setSelectionRange(newCursorPosition, newCursorPosition)
          textMethods.autoResizeTextarea(editInputRef.current)
        }
      }, 0)

      return
    }

    const firstName = member.first_name || ''
    const lastName = member.last_name || ''
    const fullName = `${firstName} ${lastName}`.trim() || 'User'
    const mentionText = `@${fullName}`

    const currentValue = editValue
    const textBeforeMention = currentValue.substring(0, editMentionStartPosition)
    const textAfterAt = currentValue.substring(editMentionStartPosition + 1)
    const mentionEndMatch = textAfterAt.match(REG_EX.MENTION_END_MATCH)
    const textToReplace = mentionEndMatch ? mentionEndMatch[0] : textAfterAt.split(/\s/)[0] || ''
    const textAfterMention = currentValue.substring(editMentionStartPosition + 1 + textToReplace.length)
    const newValue = `${textBeforeMention}${mentionText} ${textAfterMention}`

    setEditValue(newValue)
    setShowEditMentionDropdown(false)
    setEditMentionSearchTerm('')
    setEditMentionStartPosition(null)
    setSelectedEditMentionIndex(0)

    setTimeout(() => {
      if (editInputRef.current) {
        const newCursorPosition = textBeforeMention.length + mentionText.length + 1

        editInputRef.current.focus()
        editInputRef.current.setSelectionRange(newCursorPosition, newCursorPosition)
        textMethods.autoResizeTextarea(editInputRef.current)
      }
    }, 0)
  }

  const handleKeyDown = (e) => {
    // Handle mention dropdown navigation
    if (showMentionDropdown && activeCommunity?.is_internal) {
      const { members: filteredMembers } = getFilteredMentionMembers()

      if (e.key === 'ArrowDown') {
        e.preventDefault()
        setSelectedMentionIndex((prev) => (prev < filteredMembers.length - 1 ? prev + 1 : prev))

        return
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault()
        setSelectedMentionIndex((prev) => (prev > 0 ? prev - 1 : 0))

        return
      }

      if (e.key === 'Tab') {
        e.preventDefault()
        if (filteredMembers.length > 0) {
          insertMention(filteredMembers[selectedMentionIndex])
        }

        return
      }

      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        if (filteredMembers.length > 0) {
          insertMention(filteredMembers[selectedMentionIndex])
        } else {
          setShowMentionDropdown(false)
          setMentionSearchTerm('')
          setMentionStartPosition(null)
          sendMessage()
        }

        return
      }

      if (e.key === 'Escape') {
        e.preventDefault()
        setShowMentionDropdown(false)
        setMentionSearchTerm('')
        setMentionStartPosition(null)

        return
      }
    }

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      sendMessage()
    }
  }

  const handleEditKeyDown = (e) => {
    // Handle mention dropdown navigation inside edit modal
    if (showEditMentionDropdown && activeCommunity?.is_internal) {
      const { members: filteredMembers } = getFilteredEditMentionMembers()

      if (e.key === 'ArrowDown') {
        e.preventDefault()
        setSelectedEditMentionIndex((prev) => (prev < filteredMembers.length - 1 ? prev + 1 : prev))

        return
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault()
        setSelectedEditMentionIndex((prev) => (prev > 0 ? prev - 1 : 0))

        return
      }

      if (e.key === 'Enter' && filteredMembers.length > 0) {
        e.preventDefault()
        insertEditMention(filteredMembers[selectedEditMentionIndex])

        return
      }

      if (e.key === 'Escape') {
        e.preventDefault()
        setShowEditMentionDropdown(false)
        setEditMentionSearchTerm('')
        setEditMentionStartPosition(null)

        return
      }
    }

    if (e.key === 'Enter' && !e.shiftKey && editValue.trim()) {
      e.preventDefault()
      handleModalConfirm()
    }
  }

  const handleCommunityClickAction = async (communityData) => {
    if (!communityData) return

    const selectedCommunity = communityData?.isYourNews ? { ...communityData, unread_count: 0 } : communityData

    if (communityData?.isYourNews) {
      setGroupList((prev) => prev.map((item) => (String(item.id) === String(communityData.id) ? { ...item, unread_count: 0 } : item)))
      setFilteredGroupList((prev) => prev.map((item) => (String(item.id) === String(communityData.id) ? { ...item, unread_count: 0 } : item)))
      setActiveCommunity((prev) => (prev && String(prev.id) === String(communityData.id) ? { ...prev, unread_count: 0 } : prev))
    }

    if (communityData?.is_internal) handleFetchInternalCommunityMembers(communityData)

    if (communityData?.isYourNews && communityData?.id) {
      await markNewsReminderLastRead(communityData?.id || communityData?.yourNewsReminderId, userDetails?.id)
    }

    if (isCoffeePost && onCommunitySelect) {
      onCommunitySelect(selectedCommunity.id)

      return
    }

    updateCommunitySearchParam(selectedCommunity.id)

    if (String(selectedCommunity.id) === String(activeId)) return // To handle clicked the already active one

    // Update ref immediately so any in-flight fetch sees new community and ignores its response
    activeCommunityIdRef.current = selectedCommunity.id
    setActiveCommunity(selectedCommunity)
    setActiveId(selectedCommunity.id)
    // setChats([])
    setValue('')
    setRepliedMessage(null)
    setAttachments([])
    setUserRoleInCommunity(null) // Reset role when switching communities
    // Clear URL approval specific state when switching away
    setPendingUrlMessages([])
    setPendingUrlsError(null)

    // Reset preview URLs to prevent memory leaks
    attachments.forEach((att) => {
      if (att.previewUrl) {
        URL.revokeObjectURL(att.previewUrl)
      }
    })

    // inside the effect that runs on activeCommunity?.id change (you already do some reset)
    isInitialLoadRef.current = true
    hasMoreRef.current = true
    nextCursorRef.current = null
    earliestTimestampRef.current = null
    existingIdsRef.current = new Set()
    isFetchingRef.current = false // Allow new fetch to start (old fetch will be ignored via ref check)
    // setNextCursor(null) // Commented if chat scroll through cursor
    setChats([])
  }

  const handleLogin = () => {
    if (userLoginStatus === false) {
      history.push({ pathname: ROUTE_STRINGS.login, state: { personalChat: true } })
    } else {
      history.push(ROUTE_STRINGS.createAccount)
    }
  }

  function CommunitiesSkeleton() {
    return (
      <div className="skeleton-card">
        <div className="skeleton-container">
          <div>
            <Skeleton className="custom-skelton" shape="circle" size="2.25rem"></Skeleton>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', gap: '0.25rem', alignItems: 'center' }}>
            <Skeleton className="custom-skelton" width="100%" height="2rem"></Skeleton>
            <Skeleton className="custom-skelton" shape="circle" size="1rem"></Skeleton>
          </div>
        </div>
      </div>
    )
  }

  function ReceivedMessageSkeleton() {
    return (
      <div className="message-row received" aria-hidden="true">
        <div className="avatar">
          <Skeleton className="custom-skeleton" shape="circle" size="40px" />
        </div>

        <div className="skeleton-bubble">
          <div className="skeleton-bubble-header">
            <Skeleton className="custom-skeleton" width="8rem" height="0.75rem" />
          </div>

          <div className="skeleton-bubble-body">
            <Skeleton className="custom-skeleton" width="96%" height="0.85rem" />
            <Skeleton className="custom-skeleton" width="88%" height="0.85rem" />
            <Skeleton className="custom-skeleton" width="70%" height="0.85rem" />
          </div>

          <div className="skeleton-bubble-footer">
            <Skeleton className="custom-skeleton" width="5rem" height="0.7rem" />
          </div>
        </div>
      </div>
    )
  }

  function SentMessageSkeleton() {
    return (
      <div className="message-row sent" aria-hidden="true">
        <div className="skeleton-bubble">
          <div className="skeleton-bubble-body">
            <Skeleton width="92%" height="0.85rem" />
            <Skeleton width="78%" height="0.85rem" />
          </div>

          <div className="skeleton-bubble-footer">
            <Skeleton width="4.5rem" height="0.7rem" />
          </div>
        </div>
      </div>
    )
  }

  const formatDate = (timestamp) => {
    const date = new Date(timestamp)
    const today = new Date()
    const yesterday = new Date(today)

    yesterday.setDate(today.getDate() - 1)

    const isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()
    const isYesterday = date.getDate() === yesterday.getDate() && date.getMonth() === yesterday.getMonth() && date.getFullYear() === yesterday.getFullYear()

    if (isToday) {
      return 'Today'
    }

    if (isYesterday) {
      return 'Yesterday'
    }

    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  const groupedMessages = React.useMemo(() => {
    const sections = []
    const indexByLabel = Object.create(null)

    return chats.reduce((acc, m) => {
      const label = formatDate(m.timestamp)

      let idx = indexByLabel[label]

      if (idx === undefined) {
        idx = acc.length
        indexByLabel[label] = idx
        acc.push([label, []])
      }

      acc[idx][1].push(m)

      return acc
    }, sections)
  }, [chats])

  const onClickCb = React.useCallback((g) => handleCommunityClickAction(g), [handleCommunityClickAction])

  const handleDeleteForMe = async (msgObj) => {
    await deleteMessageForMe({ message_id: msgObj?.id, user_id: userDetails?.id })
    // // setChats((prev) => prev.map((msg) => (msg.id === msgObj?.id ? { ...msg, content: 'This message was deleted.' } : msg))) // approach to show deleted message text
    setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
  }

  const handleDeleteForEveryone = async (msgObj) => {
    try {
      await deleteMessageForAll({ message_id: msgObj?.id, user_id: userDetails?.id })
      // setChats((prev) => prev.map((msg) => (msg.id === msgObj?.id ? { ...msg, content: 'This message was deleted.' } : msg))) // approach to show deleted message text
      setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
    } catch (error) {
      console.log('Error deleting message for me:', error)
    }
  }

  const handleDeleteMessageByAdmin = async (msgObj) => {
    try {
      await removeMessageForAdmin({ message_id: msgObj?.id, bot_user_id: userDetails?.id })
      setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
    } catch (error) {
      console.log('Error deleting message by Admin:', error)
    }
  }

  const handleDeleteAllMessageByAdmin = async (msgObj) => {
    try {
      await removeAllMessageForUser({ target_userid: msgObj?.user_info?.userid, community_id: activeId, bot_user_id: userDetails?.id })
      setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
    } catch (error) {
      console.log('Error deleting message by Admin:', error)
    }
  }

  const handleBlockUserByAdmin = async (msgObj) => {
    try {
      await blockUserFromCommunity({ target_userid: msgObj?.user_info?.userid, community_id: activeId, bot_user_id: userDetails?.id, reason: 'Blocked by Admin' })
      // setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
    } catch (error) {
      console.log('Error deleting message by Admin:', error)
    }
  }

  const handleReportAbuse = async (msgObj) => {
    if (!selectedReportReason) return

    setIsReporting(true)

    try {
      await reportAbuse({
        p_reporter_userid: userDetails?.id,
        p_reported_userid: msgObj?.user_info?.userid,
        p_community_id: activeId,
        p_report_reason_id: selectedReportReason,
        p_message_id: msgObj?.id
      })

      setChats((prev) =>
        prev.map((msg) => {
          if (msg.id !== msgObj?.id) return msg

          const currentCount = Number.isFinite(msg?.abuse_flag_count) ? msg.abuse_flag_count : 0

          return {
            ...msg,
            abuse_flag_count: currentCount + 1,
            is_reported_by_me: true
          }
        })
      )
    } catch (error) {
      console.log('Error reporting abuse:', error)
    } finally {
      setIsReporting(false)
    }
  }
  const handleUndoReportAbuse = async (msgObj) => {
    try {
      await undoReportAbuse({
        p_reporter_userid: userDetails?.id,
        p_reported_userid: msgObj?.user_info?.userid,
        p_community_id: activeId,
        p_message_id: msgObj?.id
      })

      setChats((prev) =>
        prev.map((msg) => {
          if (msg.id !== msgObj?.id) return msg

          const currentCount = Number.isFinite(msg?.abuse_flag_count) ? msg.abuse_flag_count : 0

          return {
            ...msg,
            abuse_flag_count: currentCount - 1,
            is_reported_by_me: false
          }
        })
      )
    } catch (error) {
      console.log('Error reporting abuse:', error)
    }
  }

  const openForwardModal = (msg) => {
    if (!msg) return
    setMessageToForward(msg)
    setForwardModalVisible(true)
    setForwardSearchTerm('')
  }

  const handleChatPersonally = (msg) => {
    if (!msg?.user_info?.userid) return

    // If we have a callback from parent (CoffeePost), use it
    if (onSwitchToPersonalChat) {
      onSwitchToPersonalChat(msg.user_info.userid)

      return
    }

    const params = new URLSearchParams(location.search)
    const currentView = params.get('view')
    const targetUserId = msg.user_info.userid

    if (currentView === coffeeCommunityView) {
      // We're in coffee-community view: switch to Personal Chats tab and open this user's chat
      params.set('chatTab', 'personalChat')
      params.set('userId', targetUserId)
      history.push({
        pathname: location.pathname,
        search: params.toString()
      })
    } else if (currentView === ROUTE_STRINGS.coffeePost) {
      // We're already in coffee-post view, just switch tab
      params.set('chatTab', 'personalChat')
      params.set('userId', targetUserId)
      history.push({
        pathname: location.pathname,
        search: params.toString()
      })
    } else {
      // Navigate to coffee-post view with personalChat tab
      history.push({
        pathname: location.pathname,
        search: `?view=${ROUTE_STRINGS.coffeePost}&chatTab=personalChat&userId=${targetUserId}`
      })
    }
  }

  // Determine if we should show sidebar or chat in CoffeePostScreen mode
  const showSidebarInCoffeePost = isCoffeePost && !selectedCommunityId
  const showChatInCoffeePost = isCoffeePost && selectedCommunityId

  // Helper function to render personal chat sidebar content
  const renderPersonalChatSidebarContent = () => {
    if (!personalChatSidebarData) {
      return <div className="no-chats-message">Loading...</div>
    }

    if (personalChatSidebarData?.isLoading) {
      return (
        <>
          {Array(8)
            .fill(null)
            .map((_, index) => (
              <div key={index} className="personal-chat-skeleton">
                <Skeleton shape="circle" height="40px" width="45px" className="custom-skelton" />
                <div className="body-skeleton-wrapper">
                  <Skeleton height="2rem" className="custom-skelton" />
                  <Skeleton shape="circle" size="1rem" className="custom-skelton" />
                </div>
              </div>
            ))}
        </>
      )
    }

    if (personalChatSidebarData?.filteredPersonalChats?.length > 0) {
      return personalChatSidebarData?.filteredPersonalChats?.map((chat) => {
        const userId = chat.other_user_id || chat.user_id || chat.id
        const UserRow = personalChatSidebarData.UserRow

        return <UserRow key={userId || chat.chat_id} userData={chat} isActive={String(userId) === String(personalChatSidebarData.selectedUserId)} onClick={() => personalChatSidebarData.handleUserSelect(userId)} />
      })
    }

    if (!personalChatSidebarData.userDetails?.id) {
      return
    }

    return (
      <div className="no-chats-message logged-in-message">
        <div className="no-chats-icon-wrapper">
          <i className="pi pi-comments no-chats-icon" />
        </div>
        <div className="no-chats-content">
          <div className="no-chats-title">{t('NO_PERSONAL_CHATS_FOUND')}</div>
          <p className="no-chats-text">{t('CONVERSATION_MESSAGE')}</p>
        </div>
      </div>
    )
  }

  const handleCommunitiesTabClick = () => {
    setActiveTab('communities')
    setForwardSearchTerm('')

    if (view === coffeeCommunityView) {
      const params = new URLSearchParams(location.search)

      params.set('chatTab', 'communities')
      params.delete('userId')

      history.replace({
        pathname: location.pathname,
        search: params.toString()
      })
    }
  }

  const handlePersonalChatsTabClick = () => {
    if (userDetails?.id) {
      setActiveTab('personalChats')
      setForwardSearchTerm('')

      if (view === coffeeCommunityView) {
        const params = new URLSearchParams(location.search)

        params.set('chatTab', 'personalChat')

        history.replace({
          pathname: location.pathname,
          search: params.toString()
        })
      }
    } else {
      handleLogin()
    }
  }

  return (
    <>
      <MetaTagsComponent title={t('COFFEE_COMMUNITIES_TITLE')} description={t('COFFEE_COMMUNITIES_DESCRIPTION')} keywords={t('COFFEE_COMMUNITIES_KEYWORDS')} url="https://coffeeweb.com/coffeeweb" h1Content={t('COFFEE_COMMUNITIES_H1_CONTENT')} />

      {!userDetails || userDetails?.isCoffeeCommunityAvailable ? (
        <div className={`coffee-communities ${isCoffeePost === true ? 'coffee-post-screen' : ''}`}>
          {/* Left: community list */}
          <aside className={`community-sidebar ${isCoffeePost && showChatInCoffeePost ? 'hidden' : ''} ${isCoffeePost ? 'coffee-post-screen-communities-sidebar' : ''}`}>
            {!isCoffeePost && (
              <div className="chat-tabs-container">
                <div className={`chat-tab-item ${activeTab === 'communities' ? 'active' : ''}`} onClick={handleCommunitiesTabClick}>
                  {t('COFFEE_COMMUNITIES')}
                  {communityUnreadCount > 0 && <span className="chat-tab-badge">{communityUnreadCount > 99 ? '99+' : communityUnreadCount}</span>}
                </div>

                <div className={`chat-tab-item ${activeTab === 'personalChats' ? 'active' : ''}`} onClick={handlePersonalChatsTabClick}>
                  {t('PERSONAL_CHATS')}
                  {personalUnreadCount > 0 && <span className="chat-tab-badge">{personalUnreadCount > 99 ? '99+' : personalUnreadCount}</span>}
                </div>
              </div>
            )}

            {activeTab === 'communities' && (
              <div className="communities-label">
                <div className="community-search-input-div">
                  <InputText value={searchCommunityTerm} onChange={(e) => handleCommunitySearch(e.target.value)} placeholder="Search Communities" className="community-search-input" />

                  {searchCommunityTerm ? (
                    <button type="button" className="search-btn" onClick={() => handleCommunitySearch('')}>
                      <i className="pi pi-times" />
                    </button>
                  ) : (
                    <button type="button" className="search-btn" aria-controls="search-input" onClick={handleCommunitySearch}>
                      <i className="pi pi-search" data-testid="web-search-icon" />
                    </button>
                  )}
                </div>
                {isCommunitiesLoading ? (
                  <>
                    {Array(8)
                      .fill(null)
                      .map((_, index) => (
                        <CommunitiesSkeleton key={index} />
                      ))}
                  </>
                ) : (
                  <>
                    <div className={`community-items-container ${!userDetails ? 'guest-community-items-container' : ''} ${isCoffeePost ? 'coffee-post-screen-communities' : ''}`}>{filteredGroupList?.length > 0 ? filteredGroupList.map((groupData, index) => <CommunityRow key={groupData.id} groupData={groupData} index={index} activeId={activeId} onClick={onClickCb} isCoffeePost={isCoffeePost} />) : <div className="no-communities-message">No communities found</div>}</div>
                  </>
                )}
              </div>
            )}
            {activeTab === 'personalChats' && personalChatSidebarData && userDetails && (
              <div className="personal-chat-wrapper" style={{ display: 'contents' }}>
                <div className="personal-chat-sidebar" style={{ display: 'contents' }}>
                  <div className="search-input-div">
                    <InputText value={personalChatSidebarData.searchTerm} onChange={(e) => personalChatSidebarData.handleSearch(e.target.value)} placeholder="Search chats" className="search-input" />

                    {personalChatSidebarData.searchTerm ? (
                      <button type="button" className="search-btn" onClick={() => personalChatSidebarData.handleSearch('')}>
                        <i className="pi pi-times" />
                      </button>
                    ) : (
                      <button type="button" className="search-btn" aria-controls="search-input">
                        <i className="pi pi-search" />
                      </button>
                    )}
                  </div>
                  <div className={`personal-chat-items-container ${!personalChatSidebarData.userDetails ? 'guest-chat-items-container' : ''} ${isCoffeePost ? 'coffee-post-screen-personal-chats' : ''}`}>{renderPersonalChatSidebarContent()}</div>
                </div>
              </div>
            )}
            {activeTab === 'personalChats' && !personalChatSidebarData && (
              <div className="personal-chat-wrapper" style={{ display: 'contents' }}>
                <div className="personal-chat-sidebar" style={{ display: 'contents' }}>
                  <div className="search-input-div">
                    <InputText placeholder="Search chats" className="search-input" />
                    <button type="button" className="search-btn" aria-controls="search-input">
                      <i className="pi pi-search" />
                    </button>
                  </div>
                  <div className={`personal-chat-items-container ${!userDetails ? 'guest-chat-items-container' : ''} ${isCoffeePost ? 'coffee-post-screen-personal-chats' : ''}`}>{renderPersonalChatSidebarContent()}</div>
                </div>
              </div>
            )}
          </aside>
          {/* Right: chat area */}

          {activeTab === 'communities' ? (
            (!isCoffeePost || showChatInCoffeePost) && (
              <section className={`chat-panel ${userDetails?.id ? '' : 'guest-user'} ${hasHeader ? 'with-header' : ''}  ${activeCommunity?.isUrlApproval || activeCommunity?.isYourNews ? 'has-url' : ''}`}>
                <header className={`chat-header ${isCoffeePost ? 'coffee-post-screen-chat-header' : ''}`}>
                  <div className={`chat-header-container ${isCoffeePost ? 'coffee-post-screen-chat-header-container' : ''}`}>
                    {isCoffeePost && showChatInCoffeePost && onBackToCommunities && (
                      <button className="back-to-communities-btn" onClick={onBackToCommunities} aria-label="Back to communities">
                        <i className="pi pi-arrow-left" />
                      </button>
                    )}
                    {isCommunitiesLoading ? (
                      <div className="skeleton-container">
                        <div>
                          <Skeleton className="custom-skelton" shape="circle" size="2.25rem"></Skeleton>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', gap: '0.25rem', alignItems: 'center' }}>
                          <Skeleton className="custom-skelton" width="10rem" height="2rem"></Skeleton>
                        </div>
                      </div>
                    ) : (
                      <div className={`active-community-details ${isCoffeePost ? 'coffee-post-active-community-details' : ''}`}>
                        {activeCommunity?.isUrlApproval ? <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png" alt="active-community-logo" /> : <img alt="active-community-logo" src={activeCommunity?.community_url || 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png'} />}
                        <div className={`community-text-content ${isCoffeePost ? 'coffee-post-community-text' : ''}`}>
                          <div className={`chat-heading ${isCoffeePost ? 'coffee-post-chat-heading' : ''}`}>{activeCommunity?.name}</div>
                          {isCoffeePost && isAdminUser && userDetails && <div className="bot-user-title">{t('ADMIN')}</div>}
                        </div>
                      </div>
                    )}
                    {/* commented for the future reference */}
                    {/* <div className="search-div"> */}
                    {/* <i className="pi pi-search" onClick={() => handleInChatSearch()} data-testid="web-search-icon" /> */}
                    {/* <SearchBar onSearch={(value) => console.log('Search:', value)} /> */}
                    {/* </div> */}
                    {userDetails && !activeCommunity?.isCreateOwn && !activeCommunity?.isUrlApproval && <CommunitySubscriptionTypes subTypes={activeCommunity?.subscription_details} isCoffeePost={isCoffeePost} />}
                  </div>
                  <div className="action-container">
                    {!isCoffeePost && isAdminUser && userDetails && <div className="bot-user-title">{t('ADMIN')}</div>}
                    <img alt="invite-icon" src={theme === 'light' ? 'https://coffeeweb.s3.ap-south-1.amazonaws.com/invite-icon-dark.png' : 'https://coffeeweb.s3.ap-south-1.amazonaws.com/invite-icon-light.png'} className={`invite-icon ${isCoffeePost ? 'coffee-post-screen-invite-icon' : ''}`} onClick={invite} />
                  </div>
                </header>

                {/* Commented for Enhancement in future */}
                {/* <div className="skeleton-messages">
           {isChatLoading && (
             <>
               <div className="skeleton-bubble left">
                 <ReceivedMessageSkeleton />
               </div>
               <div className="skeleton-bubble right">
                 <SentMessageSkeleton />
               </div>
               <div className="skeleton-bubble left">
                 <ReceivedMessageSkeleton />
               </div>
               <div className="skeleton-bubble right">
                 <SentMessageSkeleton />
               </div>
             </>
           )}
         </div> */}

                {/* ========== URL Approval View / Chat View Switch =============== */}

                {renderMainContent()}
              </section>
            )
          ) : (
            <PersonalChat
              hideSidebar={true}
              onSidebarReady={setPersonalChatSidebarData}
              selectedUserId={personalChatSelectedUserId}
              onUnreadCountRefresh={isCoffeePost ? onUnreadCountRefresh : fetchUnreadCounts}
              onUserSelect={(uid) => {
                setPersonalChatSelectedUserId(uid || null)
                if (view === coffeeCommunityView && uid) {
                  const params = new URLSearchParams(location.search)

                  params.set('chatTab', 'personalChat')
                  params.set('userId', String(uid))
                  history.replace({ pathname: location.pathname, search: params.toString() })
                }
              }}
            />
          )}

          <DialogUIModal
            customClassName="confirmation-modal-coffee-communities"
            title="Blocked"
            showModal={showBlockedModal}
            bodyContent={() => <div>You have been blocked from this community and cannot send messages.</div>}
            footerContent={() => (
              <div className="confirmation-modal-buttons">
                {' '}
                <Button label="OK" className="confirmation-yes-button" onClick={() => setShowBlockedModal(false)} />{' '}
              </div>
            )}
            contentWidth="400px"
            handleClose={() => setShowBlockedModal(false)}
          />

          {/* kept it for future reference */}
          {/* <DialogUIModal
            title={viewer?.name || 'View Attachment'}
            showModal={viewer.open}
            handleClose={closeViewer}
            bodyContent={viewerModalContent}
            size={isFullscreen ? undefined : 'lg'}
            contentWidth={isFullscreen ? '100%' : '90%'}
            contentHeight={isFullscreen ? '100vh' : '80vh'}
            customClassName={`attachment-viewer-modal ${isFullscreen ? 'fullscreen-mode' : ''}`}
            headerActions={
              <button className="fullscreen-toggle-btn" onClick={() => setIsFullscreen(!isFullscreen)} aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}>
                {isFullscreen ? <img className="window-minimize-icon" src={WindowMinimizeIcon} alt="WindowMinimizeIcon" /> : <img className="window-maximize-icon" src={WindowMaximizeIcon} alt="WindowMinimizeIcon" />}
              </button>
            }
          /> */}

          {viewer.open && (
            <div className="attachment-viewer-overlay">
              <div className={`attachment-viewer-container ${isFullscreen ? 'fullscreen-mode' : ''}`}>
                <AttachmentViewerControls isImage={attachmentMethods.isImageAttachment(viewer.type)} canZoomIn={zoomLevel < 5} canZoomOut={zoomLevel > 1} onZoomIn={handleZoomIn} onZoomOut={handleZoomOut} onClose={closeViewer} />

                <div className="attachment-viewer-content">{viewerModalContent()}</div>
              </div>
            </div>
          )}
          <DialogUIModal customClassName="confirmation-modal-coffee-communities" title={modalTitle} showModal={confirmationModal} bodyContent={confirmationModalContent} footerContent={footerContent} contentWidth={modalAction === 'edit' || modalAction === 'reportAbuse' ? '43%' : '450px'} handleClose={() => setConfirmationModal(false)} />
          <DialogUIModal title={t('SHARE_MODAL')} showModal={isModalVisible} handleClose={() => setIsModalVisible(false)} bodyContent={shareListModalContent} shareNews={true} titlePosition="center" testId="share-news-feed-dialog-modal" customClassName="community-share-modal" />

          <ForwardMessageModal setSelectedCommunitiesForForward={setSelectedCommunitiesForForward} selectedCommunitiesForForward={selectedCommunitiesForForward} groupList={groupList} setForwardSearchTerm={setForwardSearchTerm} forwardSearchTerm={forwardSearchTerm} handleForwardToCommunity={handleForwardToCommunity} isForwarding={isForwarding} setForwardModalVisible={setForwardModalVisible} forwardModalVisible={forwardModalVisible} setMessageToForward={setMessageToForward} messageToForward={messageToForward} isAdminUser={isAdminUser} />
        </div>
      ) : (
        <ComingSoonPopUp />
      )}
    </>
  )
}

export default CoffeeCommunities
